var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramStatusFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -8,
    width: 104.43,
    height: 104
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_550_14846_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9324 13.4572C48.7483 13.5827 50.308 14.3636 50.0195 16.4825C49.8213 17.9382 49.1216 18.5921 48.4659 19.2049C47.9286 19.707 47.4209 20.1815 47.2431 21.047C47.2241 20.1638 46.8102 19.6064 46.372 19.0165C45.8374 18.2967 45.2668 17.5285 45.3341 16.0611C45.432 13.925 47.1071 13.4351 47.9324 13.4572Z",
    fill: "url(#paint0_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1754 72.3164C39.375 72.1152 37.8958 71.192 38.383 69.1094C38.7177 67.6787 39.476 67.093 40.1865 66.5443C40.7689 66.0945 41.3191 65.6695 41.5777 64.8245C41.5133 65.7055 41.8729 66.2992 42.2534 66.9274C42.7178 67.694 43.2133 68.5121 43.0079 69.9667C42.7089 72.0842 40.995 72.4155 40.1754 72.3164Z",
    fill: "url(#paint1_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4833 15.4587C56.2387 15.7902 57.5422 16.9462 56.7124 18.9186C56.1423 20.2736 55.2964 20.725 54.5037 21.148C53.8541 21.4946 53.2403 21.8222 52.8434 22.6124C53.0548 21.7544 52.7999 21.1094 52.5301 20.4267C52.2009 19.5938 51.8496 18.7048 52.2962 17.3047C52.9464 15.2667 54.6918 15.2249 55.4833 15.4587Z",
    fill: "url(#paint2_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6824 70.3145C31.9615 69.9139 30.7729 68.6413 31.7851 66.7551C32.4804 65.4594 33.3653 65.089 34.1943 64.7419C34.8738 64.4575 35.5158 64.1887 35.9854 63.4391C35.694 64.2735 35.887 64.9395 36.0912 65.6443C36.3403 66.5044 36.6062 67.4222 36.0294 68.7744C35.1899 70.7427 33.4482 70.6213 32.6824 70.3145Z",
    fill: "url(#paint3_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2561 19.322C62.8996 19.8368 63.858 21.2891 62.5435 22.9805C61.6405 24.1425 60.706 24.3607 59.8303 24.5651C59.1126 24.7327 58.4345 24.891 57.8457 25.552C58.273 24.7777 58.1946 24.089 58.1115 23.3601C58.0102 22.4708 57.9021 21.5216 58.6976 20.2842C59.8557 18.4831 61.5525 18.8923 62.2561 19.322Z",
    fill: "url(#paint4_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9652 66.436C25.3731 65.8634 24.5559 64.328 26.0242 62.7668C27.0329 61.6943 27.9839 61.5644 28.8749 61.4427C29.6052 61.3429 30.2953 61.2487 30.9439 60.6456C30.4454 61.3765 30.4585 62.0695 30.4724 62.8029C30.4894 63.6978 30.5075 64.6529 29.5988 65.8105C28.2759 67.4955 26.6252 66.9296 25.9652 66.436Z",
    fill: "url(#paint5_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7895 24.7838C68.2772 25.4467 68.8252 27.0964 67.1156 28.3916C65.9411 29.2815 64.9817 29.2515 64.0827 29.2234C63.3459 29.2004 62.6497 29.1786 61.9091 29.6655C62.5232 29.0277 62.6265 28.3422 62.7359 27.6168C62.8693 26.7316 63.0117 25.7869 64.102 24.7967C65.689 23.3552 67.2216 24.1875 67.7895 24.7838Z",
    fill: "url(#paint6_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4817 60.9451C20.0587 60.2396 19.6687 58.546 21.493 57.4162C22.7462 56.64 23.6986 56.7595 24.591 56.8715C25.3223 56.9632 26.0134 57.0499 26.7967 56.6344C26.1251 57.212 25.9576 57.8848 25.7802 58.5968C25.5639 59.4656 25.333 60.3928 24.1541 61.2768C22.4381 62.5637 20.9908 61.5919 20.4817 60.9451Z",
    fill: "url(#paint7_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7063 31.4718C72.005 32.2377 72.1052 33.9723 70.117 34.7831C68.7511 35.3401 67.8322 35.0641 66.9711 34.8054C66.2654 34.5934 65.5986 34.3931 64.7566 34.6726C65.5157 34.2147 65.7937 33.5792 66.088 32.9066C66.4471 32.086 66.8304 31.2102 68.1411 30.5344C70.0489 29.5508 71.3128 30.7495 71.7063 31.4718Z",
    fill: "url(#paint8_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6055 54.2162C16.3805 53.4258 16.4443 51.6895 18.5002 51.068C19.9126 50.6411 20.8015 51.0018 21.6343 51.3397C22.3169 51.6167 22.9618 51.8785 23.8265 51.6788C23.0276 52.0638 22.6908 52.6705 22.3343 53.3126C21.8994 54.0961 21.4352 54.9322 20.0666 55.4825C18.0744 56.2835 16.9291 54.9721 16.6055 54.2162Z",
    fill: "url(#paint9_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7395 38.9302C73.8288 39.747 73.4746 41.4483 71.3432 41.7194C69.879 41.9056 69.0631 41.4022 68.2987 40.9306C67.6722 40.5441 67.0802 40.1789 66.1942 40.232C67.0465 39.9852 67.4804 39.443 67.9396 38.8691C68.4999 38.1689 69.0978 37.4217 70.5396 37.1065C72.6383 36.6478 73.5473 38.1312 73.7395 38.9302Z",
    fill: "url(#paint10_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6009 46.7078C14.5891 45.8863 15.1023 44.2256 17.2498 44.1548C18.7251 44.1062 19.4899 44.6836 20.2064 45.2245C20.7937 45.6679 21.3486 46.0868 22.2358 46.1167C21.3639 46.2828 20.8808 46.7821 20.3695 47.3105C19.7456 47.9552 19.0798 48.6433 17.6147 48.8224C15.482 49.083 14.7169 47.5212 14.6009 46.7078Z",
    fill: "url(#paint11_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7507 46.6508C73.6245 47.4628 72.8398 49.0149 70.7106 48.7277C69.2478 48.5305 68.5907 47.8342 67.975 47.1817C67.4703 46.647 66.9935 46.1417 66.1238 45.9648C67.0113 45.946 67.5714 45.534 68.1642 45.098C68.8875 44.5659 69.6595 43.9981 71.1341 44.0651C73.2805 44.1626 73.7728 45.8295 73.7507 46.6508Z",
    fill: "url(#paint12_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6044 38.9315C14.8066 38.1349 15.7342 36.663 17.827 37.1478C19.2647 37.4808 19.8532 38.2355 20.4047 38.9426C20.8566 39.5221 21.2836 40.0696 22.1328 40.327C21.2475 40.2629 20.651 40.6207 20.0197 40.9994C19.2493 41.4615 18.4272 41.9547 16.9655 41.7503C14.8377 41.4527 14.5048 39.7471 14.6044 38.9315Z",
    fill: "url(#paint13_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7394 54.165C71.4063 54.9168 70.2447 56.2139 68.2627 55.3882C66.9011 54.8209 66.4474 53.979 66.0224 53.1902C65.674 52.5437 65.3448 51.9329 64.5508 51.538C65.4129 51.7484 66.0611 51.4947 66.7471 51.2262C67.5841 50.8986 68.4775 50.549 69.8844 50.9935C71.9324 51.6405 71.9744 53.3774 71.7394 54.165Z",
    fill: "url(#paint14_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6161 31.4748C17.0186 30.7575 18.2974 29.5747 20.1928 30.5819C21.4949 31.2739 21.8671 32.1544 22.2159 32.9795C22.5017 33.6556 22.7718 34.2945 23.525 34.7619C22.6866 34.4719 22.0173 34.6639 21.309 34.8671C20.4448 35.115 19.5224 35.3797 18.1636 34.8057C16.1857 33.9702 16.3078 32.237 16.6161 31.4748Z",
    fill: "url(#paint15_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8573 60.9051C67.34 61.5454 65.8806 62.4991 64.1809 61.191C63.0132 60.2924 62.794 59.3624 62.5886 58.491C62.4202 57.7768 62.2612 57.102 61.5969 56.516C62.3749 56.9413 63.067 56.8632 63.7994 56.7806C64.6932 56.6797 65.647 56.5721 66.8903 57.3638C68.7003 58.5162 68.2891 60.2048 67.8573 60.9051Z",
    fill: "url(#paint16_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5135 24.7903C21.0889 24.2011 22.6318 23.3879 24.2006 24.8491C25.2784 25.8528 25.4089 26.7992 25.5312 27.686C25.6314 28.4127 25.7261 29.0994 26.3322 29.7448C25.5977 29.2488 24.9013 29.2618 24.1643 29.2757C23.265 29.2926 22.3053 29.3106 21.1421 28.4063C19.4489 27.0898 20.0176 25.4471 20.5135 24.7903Z",
    fill: "url(#paint17_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3689 66.4116C61.7027 66.8969 60.045 67.4422 58.7434 65.7409C57.8493 64.5721 57.8794 63.6174 57.9076 62.7227C57.9307 61.9895 57.9526 61.2967 57.4633 60.5597C58.1043 61.1708 58.7931 61.2736 59.5221 61.3825C60.4115 61.5152 61.3608 61.657 62.3559 62.7419C63.8045 64.3213 62.9681 65.8464 62.3689 66.4116Z",
    fill: "url(#paint18_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0311 19.3334C26.7401 18.9125 28.442 18.5244 29.5773 20.3398C30.3572 21.587 30.2372 22.5347 30.1247 23.4228C30.0325 24.1506 29.9454 24.8383 30.3629 25.6178C29.7825 24.9494 29.1064 24.7827 28.3909 24.6063C27.5179 24.391 26.5862 24.1612 25.6978 22.9881C24.4047 21.2804 25.3812 19.8401 26.0311 19.3334Z",
    fill: "url(#paint19_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6483 70.3093C54.8786 70.6065 53.1355 70.7063 52.3208 68.7277C51.7611 67.3685 52.0385 66.454 52.2984 65.5971C52.5114 64.8949 52.7127 64.2313 52.4318 63.3933C52.892 64.1487 53.5306 64.4255 54.2064 64.7183C55.0311 65.0757 55.9111 65.4571 56.5902 66.7614C57.5786 68.66 56.3741 69.9178 55.6483 70.3093Z",
    fill: "url(#paint20_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7929 15.4761C33.5872 15.2521 35.332 15.3156 35.9565 17.3616C36.3855 18.7671 36.023 19.6516 35.6834 20.4804C35.405 21.1597 35.142 21.8015 35.3426 22.662C34.9558 21.867 34.3461 21.5318 33.7009 21.1771C32.9136 20.7442 32.0734 20.2823 31.5204 18.9203C30.7155 16.9378 32.0333 15.7981 32.7929 15.4761Z",
    fill: "url(#paint21_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1535 72.3327C47.3327 72.4215 45.6231 72.069 45.3507 69.948C45.1636 68.4909 45.6694 67.679 46.1433 66.9183C46.5317 66.2948 46.8987 65.7057 46.8453 64.8239C47.0933 65.6721 47.6382 66.1039 48.2148 66.5609C48.9184 67.1184 49.6694 67.7135 49.986 69.1483C50.447 71.2368 48.9564 72.1414 48.1535 72.3327Z",
    fill: "url(#paint22_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3379 13.4812C41.1634 13.4694 42.8322 13.9801 42.9033 16.1172C42.9522 17.5853 42.372 18.3464 41.8284 19.0595C41.3829 19.6439 40.9619 20.1961 40.9319 21.079C40.765 20.2113 40.2632 19.7306 39.7323 19.2218C39.0844 18.6009 38.3929 17.9383 38.213 16.4803C37.9511 14.358 39.5205 13.5966 40.3379 13.4812Z",
    fill: "url(#paint23_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2681 30.3791C45.4607 28.5783 46.1531 26.4313 46.1531 24.1262C46.1531 21.8211 45.4607 19.6741 44.2681 17.8733C43.0755 19.6741 42.383 21.8211 42.383 24.1262C42.383 26.4313 43.0755 28.5783 44.2681 30.3791Z",
    fill: "url(#paint24_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2681 67.8967C45.4607 66.0959 46.1531 63.9489 46.1531 61.6438C46.1531 59.3387 45.4607 57.1917 44.2681 55.3909C43.0755 57.1917 42.383 59.3387 42.383 61.6438C42.383 63.9489 43.0755 66.0959 44.2681 67.8967Z",
    fill: "url(#paint25_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5206 30.8052C49.1409 29.3729 50.3682 27.4775 50.9677 25.2509C51.5672 23.0243 51.4568 20.7722 50.7732 18.7255C49.1528 20.1578 47.9256 22.0533 47.3261 24.2799C46.7266 26.5064 46.837 28.7586 47.5206 30.8052Z",
    fill: "url(#paint26_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.763 67.0444C39.3833 65.6121 40.6106 63.7167 41.2101 61.4901C41.8096 59.2635 41.6991 57.0114 41.0155 54.9647C39.3952 56.397 38.168 58.2925 37.5685 60.5191C36.969 62.7457 37.0794 64.9978 37.763 67.0444Z",
    fill: "url(#paint27_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5515 32.0546C52.4892 31.0884 54.1676 29.5736 55.3257 27.5773C56.4839 25.581 56.963 23.3772 56.835 21.2242C54.8973 22.1904 53.2189 23.7052 52.0608 25.7015C50.9026 27.6977 50.4235 29.9016 50.5515 32.0546Z",
    fill: "url(#paint28_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7012 64.5458C33.6389 63.5796 35.3172 62.0648 36.4754 60.0685C37.6336 58.0723 38.1127 55.8684 37.9847 53.7154C36.047 54.6816 34.3686 56.1964 33.2105 58.1927C32.0523 60.1889 31.5732 62.3928 31.7012 64.5458Z",
    fill: "url(#paint29_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1542 34.042C55.2771 33.6078 57.2923 32.5769 58.9302 30.9469C60.5681 29.317 61.604 27.3116 62.0403 25.199C59.9175 25.6332 57.9023 26.6641 56.2644 28.2941C54.6265 29.924 53.5905 31.9294 53.1542 34.042Z",
    fill: "url(#paint30_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4958 60.5709C28.6187 60.1368 30.6339 59.1059 32.2718 57.4759C33.9097 55.846 34.9456 53.8406 35.3819 51.728C33.2591 52.1622 31.2439 53.1931 29.606 54.823C27.9681 56.453 26.9321 58.4584 26.4958 60.5709Z",
    fill: "url(#paint31_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1513 36.632C57.3148 36.7594 59.5294 36.2827 61.5355 35.1301C63.5415 33.9776 65.0637 32.3074 66.0345 30.3791C63.8711 30.2517 61.6564 30.7285 59.6504 31.881C57.6444 33.0336 56.1222 34.7038 55.1513 36.632Z",
    fill: "url(#paint32_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5016 55.3908C24.6651 55.5182 26.8797 55.0415 28.8858 53.889C30.8918 52.7364 32.414 51.0662 33.3848 49.1379C31.2214 49.0106 29.0067 49.4873 27.0007 50.6398C24.9947 51.7924 23.4725 53.4626 22.5016 55.3908Z",
    fill: "url(#paint33_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4068 39.6482C58.4634 40.3285 60.7265 40.4384 62.964 39.8418C65.2014 39.2452 67.1061 38.0239 68.5454 36.4115C66.4888 35.7312 64.2256 35.6213 61.9882 36.2179C59.7508 36.8145 57.846 38.0358 56.4068 39.6482Z",
    fill: "url(#paint34_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 49.3585C22.0474 50.0388 24.3105 50.1487 26.5479 49.5521C28.7854 48.9555 30.6901 47.7342 32.1294 46.1218C30.0728 45.4415 27.8096 45.3316 25.5722 45.9282C23.3347 46.5248 21.43 47.746 19.9907 49.3585Z",
    fill: "url(#paint35_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.835 42.885C58.6446 44.0718 60.8021 44.7609 63.1184 44.7609C65.4348 44.7609 67.5922 44.0718 69.4018 42.885C67.5922 41.6982 65.4348 41.0091 63.1184 41.0091C60.802 41.0091 58.6446 41.6982 56.835 42.885Z",
    fill: "url(#paint36_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1344 42.885C20.944 44.0718 23.1014 44.7609 25.4178 44.7609C27.7341 44.7609 29.8916 44.0718 31.7012 42.885C29.8916 41.6982 27.7341 41.0091 25.4178 41.0091C23.1014 41.0091 20.944 41.6982 19.1344 42.885Z",
    fill: "url(#paint37_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4068 46.1217C57.8461 47.7342 59.7508 48.9555 61.9882 49.5521C64.2256 50.1487 66.4888 50.0388 68.5454 49.3585C67.1061 47.746 65.2014 46.5248 62.964 45.9282C60.7265 45.3316 58.4634 45.4415 56.4068 46.1217Z",
    fill: "url(#paint38_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9908 36.4115C21.43 38.0239 23.3348 39.2452 25.5722 39.8418C27.8096 40.4384 30.0728 40.3285 32.1294 39.6482C30.6901 38.0358 28.7854 36.8145 26.5479 36.2179C24.3105 35.6213 22.0474 35.7312 19.9908 36.4115Z",
    fill: "url(#paint39_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1467 49.1473C56.1182 51.0725 57.6406 52.7404 59.6466 53.8917C61.6525 55.0431 63.8667 55.5199 66.0295 55.3937C65.0581 53.4685 63.5356 51.8006 61.5296 50.6492C59.5237 49.4979 57.3095 49.0211 55.1467 49.1473Z",
    fill: "url(#paint40_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4982 30.4079C23.4696 32.3331 24.9921 34.001 26.998 35.1524C29.004 36.3038 31.2182 36.7806 33.381 36.6544C32.4095 34.7292 30.8871 33.0613 28.8811 31.9099C26.8752 30.7586 24.661 30.2817 22.4982 30.4079Z",
    fill: "url(#paint41_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1513 51.7375C53.5889 53.8473 54.6257 55.8505 56.2639 57.4793C57.902 59.108 59.9168 60.1389 62.0387 60.574C61.601 58.4643 60.5642 56.461 58.9261 54.8323C57.2879 53.2035 55.2732 52.1726 53.1513 51.7375Z",
    fill: "url(#paint42_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.489 25.2276C26.9266 27.3374 27.9635 29.3406 29.6016 30.9694C31.2398 32.5982 33.2545 33.6291 35.3764 34.0642C34.9388 31.9544 33.902 29.9512 32.2638 28.3224C30.6257 26.6936 28.6109 25.6627 26.489 25.2276Z",
    fill: "url(#paint43_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5502 53.7254C50.4242 55.876 50.9047 58.078 52.0634 60.0733C53.2221 62.0685 54.9001 63.5831 56.8365 64.55C56.9625 62.3993 56.482 60.1973 55.3233 58.2021C54.1646 56.2069 52.4866 54.6923 50.5502 53.7254Z",
    fill: "url(#paint44_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6912 21.2517C31.5652 23.4023 32.0457 25.6043 33.2044 27.5995C34.3631 29.5947 36.041 31.1094 37.9775 32.0762C38.1035 29.9256 37.623 27.7236 36.4643 25.7284C35.3056 23.7332 33.6276 22.2185 31.6912 21.2517Z",
    fill: "url(#paint45_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5207 54.9757C46.8397 57.0206 46.7311 59.2713 47.3314 61.497C47.9317 63.7227 49.1586 65.6179 50.7776 67.0506C51.4586 65.0057 51.5672 62.7549 50.9669 60.5293C50.3666 58.3036 49.1397 56.4084 47.5207 54.9757Z",
    fill: "url(#paint46_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7501 18.7511C37.0691 20.796 36.9605 23.0467 37.5608 25.2724C38.1611 27.498 39.388 29.3933 41.007 30.8259C41.688 28.7811 41.7966 26.5303 41.1963 24.3047C40.596 22.079 39.3691 20.1838 37.7501 18.7511Z",
    fill: "url(#paint47_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3458 12.5596C43.6138 13.9925 44.1276 15.2076 44.226 15.636C44.9191 14.0276 44.7352 14.7333 46.1956 12.3234C47.3639 10.3955 47.1269 8.54206 46.8623 7.85635C46.645 7.34023 46.0164 6.09881 45.2411 5.26206C44.4658 4.4253 44.0314 3.02498 43.9111 2.42941C43.7366 3.8215 43.379 4.73887 42.6386 5.65723C42.0462 6.39192 41.5951 7.5871 41.4436 8.09286C41.216 8.98475 41.0778 11.1268 42.3458 12.5596Z",
    fill: "url(#paint48_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3458 80.9667C43.6138 82.3996 44.1276 83.6147 44.226 84.0431C44.9191 82.4347 44.7352 83.1404 46.1956 80.7305C47.3639 78.8026 47.1269 76.9492 46.8623 76.2635C46.645 75.7474 46.0164 74.5059 45.2411 73.6692C44.4658 72.8324 44.0314 71.4321 43.9111 70.8365C43.7366 72.2286 43.379 73.146 42.6386 74.0643C42.0462 74.799 41.5951 75.9942 41.4436 76.5C41.216 77.3919 41.0778 79.5339 42.3458 80.9667Z",
    fill: "url(#paint49_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3915 13.1245C51.2436 14.8352 51.4239 16.1412 51.4075 16.5803C52.4953 15.2053 52.1341 15.8396 54.1715 13.8879C55.8014 12.3266 56.0545 10.4753 55.9773 9.74481C55.9016 9.19029 55.6173 7.82928 55.0861 6.82135C54.5548 5.81342 54.4994 4.34892 54.5381 3.74266C54.0075 5.04237 53.4234 5.83637 52.4694 6.53273C51.7062 7.08983 50.9596 8.12809 50.6817 8.57758C50.2299 9.38047 49.5393 11.4139 50.3915 13.1245Z",
    fill: "url(#paint50_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6001 79.2007C33.4522 80.9113 33.6325 82.2173 33.6161 82.6565C34.7039 81.2814 34.3427 81.9158 36.3801 79.9641C38.01 78.4028 38.2631 76.5515 38.1859 75.821C38.1102 75.2665 37.8259 73.9055 37.2947 72.8975C36.7634 71.8896 36.708 70.4251 36.7467 69.8188C36.2161 71.1185 35.632 71.9126 34.678 72.6089C33.9148 73.166 33.1682 74.2043 32.8903 74.6538C32.4385 75.4566 31.7479 77.4901 32.6001 79.2007Z",
    fill: "url(#paint51_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0161 15.7424C58.3943 17.6143 58.2287 18.9222 58.0987 19.3422C59.507 18.2941 58.9932 18.8138 61.4688 17.4534C63.4492 16.3651 64.1752 14.642 64.2906 13.9166C64.3617 13.3615 64.4411 11.9736 64.1901 10.8632C63.9391 9.75277 64.2664 8.32389 64.4615 7.74825C63.6109 8.86702 62.8403 9.48353 61.7376 9.91045C60.8555 10.252 59.8643 11.0626 59.479 11.4252C58.8338 12.0843 57.6379 13.8706 58.0161 15.7424Z",
    fill: "url(#paint52_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6457 74.9847C24.0239 76.8566 23.8584 78.1645 23.7283 78.5845C25.1367 77.5364 24.6229 78.0561 27.0984 76.6957C29.0789 75.6074 29.8048 73.8844 29.9202 73.1589C29.9913 72.6038 30.0707 71.2159 29.8197 70.1055C29.5687 68.9951 29.8961 67.5662 30.0911 66.9906C29.2406 68.1093 28.4699 68.7258 27.3673 69.1528C26.4852 69.4943 25.494 70.3049 25.1086 70.6675C24.4634 71.3266 23.2675 73.1129 23.6457 74.9847Z",
    fill: "url(#paint53_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7 20.2349C64.5785 22.1404 64.0784 23.3611 63.8435 23.7333C65.4765 23.0837 64.845 23.4534 67.5901 22.7769C69.7861 22.2358 70.9354 20.7584 71.2356 20.0874C71.4486 19.5695 71.8863 18.2494 71.9326 17.1121C71.979 15.9749 72.6668 14.679 73.0049 14.1733C71.8923 15.0348 70.9876 15.4318 69.8115 15.5602C68.8707 15.6629 67.7024 16.1906 67.2359 16.4416C66.4412 16.9121 64.8215 18.3295 64.7 20.2349Z",
    fill: "url(#paint54_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0929 68.6061C15.9714 70.5116 15.4713 71.7323 15.2365 72.1045C16.8695 71.4549 16.238 71.8245 18.983 71.1481C21.179 70.6069 22.3284 69.1296 22.6285 68.4586C22.8416 67.9407 23.2792 66.6206 23.3256 65.4833C23.3719 64.3461 24.0597 63.0502 24.3978 62.5444C23.2853 63.406 22.3806 63.803 21.2045 63.9314C20.2636 64.0341 19.0954 64.5618 18.6288 64.8128C17.8342 65.2833 16.2145 66.7007 16.0929 68.6061Z",
    fill: "url(#paint55_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9877 26.2959C69.3748 28.1051 68.5743 29.1555 68.2506 29.4545C69.9969 29.2476 69.2908 29.442 72.1182 29.4956C74.3801 29.5385 75.8746 28.4076 76.339 27.8367C76.6795 27.3913 77.4456 26.2289 77.7861 25.1424C78.1266 24.0558 79.1281 22.9813 79.5862 22.5798C78.2875 23.1255 77.3103 23.2759 76.1409 23.097C75.2054 22.9539 73.9397 23.1627 73.4238 23.285C72.5339 23.5348 70.6007 24.4867 69.9877 26.2959Z",
    fill: "url(#paint56_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4565 60.4995C9.84351 62.3088 9.04299 63.3591 8.71934 63.6581C10.4656 63.4512 9.75953 63.6456 12.5869 63.6992C14.8489 63.7421 16.3433 62.6112 16.8077 62.0403C17.1482 61.5949 17.9143 60.4325 18.2548 59.346C18.5954 58.2594 19.5968 57.1849 20.0549 56.7834C18.7562 57.3291 17.7791 57.4795 16.6096 57.3006C15.6741 57.1575 14.4084 57.3663 13.8925 57.4886C13.0026 57.7384 11.0694 58.6903 10.4565 60.4995Z",
    fill: "url(#paint57_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.519 33.5123C72.4564 35.102 71.4099 35.9104 71.0195 36.1158C72.7601 36.3658 72.0275 36.3717 74.7447 37.1517C76.9184 37.7757 78.656 37.0682 79.2531 36.6364C79.6978 36.2939 80.7401 35.3684 81.3516 34.4066C81.9631 33.4448 83.2099 32.6648 83.7569 32.395C82.3605 32.5876 81.3775 32.4812 80.2945 32.0072C79.428 31.628 78.1512 31.5037 77.621 31.4889C76.6964 31.501 74.5816 31.9226 73.519 33.5123Z",
    fill: "url(#paint58_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12046 51.2174C6.05785 52.8071 5.01143 53.6155 4.62105 53.8209C6.36161 54.0709 5.62902 54.0768 8.34615 54.8568C10.5198 55.4809 12.2575 54.7733 12.8546 54.3416C13.2993 53.999 14.3416 53.0736 14.9531 52.1117C15.5646 51.1499 16.8114 50.3699 17.3583 50.1001C15.962 50.2927 14.979 50.1864 13.8959 49.7123C13.0295 49.3331 11.7527 49.2088 11.2225 49.1941C10.2979 49.2061 8.18307 49.6277 7.12046 51.2174Z",
    fill: "url(#paint59_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.053 41.3923C73.6131 42.6542 72.3922 43.1654 71.9616 43.2634C73.5779 43.9531 72.8687 43.7701 75.2904 45.2234C77.2277 46.386 79.0902 46.1502 79.7792 45.8869C80.2979 45.6706 81.5453 45.0451 82.3862 44.2736C83.227 43.502 84.6342 43.0697 85.2326 42.95C83.8338 42.7763 82.9119 42.4204 81.9891 41.6836C81.2508 41.0942 80.0498 40.6452 79.5416 40.4944C78.6453 40.268 76.4929 40.1305 75.053 41.3923Z",
    fill: "url(#paint60_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3122 41.3924C4.87235 42.6542 3.65135 43.1655 3.22083 43.2634C4.83708 43.9532 4.12791 43.7702 6.54958 45.2235C8.48692 46.3861 10.3494 46.1502 11.0384 45.887C11.557 45.6707 12.8045 45.0452 13.6454 44.2736C14.4862 43.5021 15.8934 43.0698 16.4918 42.9501C15.0929 42.7764 14.1711 42.4205 13.2483 41.6837C12.51 41.0943 11.309 40.6453 10.8008 40.4945C9.90451 40.268 7.75206 40.1305 6.3122 41.3924Z",
    fill: "url(#paint61_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4853 49.3989C72.7664 50.2469 71.454 50.4263 71.0127 50.41C72.3945 51.4925 71.757 51.1332 73.7182 53.1606C75.2872 54.7826 77.1475 55.0345 77.8815 54.9577C78.4388 54.8823 79.8064 54.5994 80.8193 54.0708C81.8321 53.5421 83.3038 53.4869 83.913 53.5254C82.6069 52.9974 81.8091 52.4162 81.1093 51.4668C80.5495 50.7073 79.5062 49.9643 79.0545 49.6877C78.2477 49.2381 76.2043 48.5509 74.4853 49.3989Z",
    fill: "url(#paint62_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08684 31.6939C6.36786 32.5419 5.05549 32.7213 4.61418 32.705C5.99595 33.7876 5.35854 33.4282 7.31973 35.4556C8.88867 37.0776 10.749 37.3295 11.483 37.2527C12.0403 37.1773 13.4079 36.8944 14.4208 36.3658C15.4336 35.8371 16.9053 35.7819 17.5145 35.8204C16.2084 35.2924 15.4106 34.7112 14.7108 33.7618C14.151 33.0023 13.1076 32.2593 12.656 31.9827C11.8492 31.5331 9.80582 30.8459 8.08684 31.6939Z",
    fill: "url(#paint63_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8547 56.9865C69.9737 57.3629 68.6594 57.1981 68.2374 57.0687C69.2905 58.4703 68.7683 57.9589 70.1354 60.4225C71.229 62.3933 72.9604 63.1157 73.6894 63.2306C74.2473 63.3013 75.6419 63.3803 76.7577 63.1305C77.8736 62.8808 79.3094 63.2065 79.8878 63.4006C78.7636 62.5542 78.1441 61.7873 77.7151 60.69C77.3719 59.8122 76.5574 58.8258 76.193 58.4423C75.5306 57.8002 73.7356 56.6102 71.8547 56.9865Z",
    fill: "url(#paint64_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3234 22.783C10.4424 23.1594 9.12813 22.9946 8.7061 22.8652C9.75925 24.2668 9.23703 23.7555 10.6041 26.219C11.6977 28.1898 13.4291 28.9122 14.1582 29.0271C14.716 29.0978 16.1106 29.1768 17.2264 28.9271C18.3423 28.6773 19.7781 29.003 20.3566 29.1971C19.2323 28.3507 18.6128 27.5838 18.1838 26.4865C17.8406 25.6087 17.0261 24.6223 16.6617 24.2388C15.9993 23.5968 14.2044 22.4067 12.3234 22.783Z",
    fill: "url(#paint65_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3402 63.638C65.4255 63.5171 64.1988 63.0194 63.8248 62.7857C64.4776 64.4108 64.1061 63.7824 64.7859 66.514C65.3297 68.6994 66.8142 69.8432 67.4885 70.1419C68.009 70.3539 69.3355 70.7894 70.4783 70.8355C71.6211 70.8816 72.9233 71.5661 73.4315 71.9026C72.5657 70.7954 72.1668 69.8951 72.0378 68.7247C71.9346 67.7884 71.4043 66.6258 71.1521 66.1616C70.6793 65.3708 69.255 63.7589 67.3402 63.638Z",
    fill: "url(#paint66_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7331 15.2669C16.8184 15.146 15.5917 14.6484 15.2177 14.4147C15.8705 16.0397 15.499 15.4113 16.1788 18.143C16.7226 20.3283 18.2071 21.4721 18.8814 21.7708C19.4018 21.9828 20.7284 22.4183 21.8712 22.4645C23.0139 22.5106 24.3161 23.1951 24.8244 23.5315C23.9586 22.4244 23.5597 21.5241 23.4307 20.3537C23.3275 19.4174 22.7972 18.2548 22.545 17.7905C22.0722 16.9997 20.6479 15.3879 18.7331 15.2669Z",
    fill: "url(#paint67_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2497 68.9001C59.4316 68.2901 58.3762 67.4935 58.0757 67.1714C58.2836 68.9092 58.0882 68.2065 58.0344 71.0202C57.9912 73.2712 59.1277 74.7583 59.7014 75.2205C60.1489 75.5593 61.317 76.3217 62.4089 76.6606C63.5007 76.9995 64.5805 77.996 64.9839 78.452C64.4356 77.1595 64.2844 76.1871 64.4642 75.0234C64.608 74.0924 64.3982 72.8329 64.2753 72.3195C64.0243 71.4338 63.0677 69.5101 61.2497 68.9001Z",
    fill: "url(#paint68_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8793 9.65786C25.0612 9.04789 24.0058 8.25125 23.7053 7.92917C23.9132 9.66697 23.7178 8.96431 23.6639 11.778C23.6208 14.0289 24.7573 15.5161 25.331 15.9783C25.7785 16.3171 26.9466 17.0795 28.0384 17.4184C29.1303 17.7572 30.2101 18.7538 30.6135 19.2097C30.0652 17.9173 29.914 16.9449 30.0938 15.7812C30.2376 14.8502 30.0278 13.5907 29.9049 13.0773C29.6539 12.1916 28.6973 10.2678 26.8793 9.65786Z",
    fill: "url(#paint69_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9981 72.4142C52.4006 71.3567 51.5883 70.3154 51.3819 69.9269C51.1307 71.659 51.1247 70.93 50.3409 73.6339C49.7139 75.7971 50.4248 77.5263 50.8587 78.1205C51.2029 78.563 52.1329 79.6002 53.0994 80.2088C54.0659 80.8174 54.8497 82.0581 55.1208 82.6024C54.9273 81.2128 55.0342 80.2345 55.5105 79.1568C55.8916 78.2945 56.0165 77.0239 56.0313 76.4963C56.0192 75.5762 55.5956 73.4716 53.9981 72.4142Z",
    fill: "url(#paint70_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2066 6.33805C34.6092 5.28059 33.7969 4.23926 33.5904 3.85077C33.3392 5.58289 33.3333 4.85386 32.5495 7.55779C31.9224 9.72093 32.6334 11.4501 33.0672 12.0443C33.4114 12.4869 34.3414 13.5241 35.3079 14.1327C36.2744 14.7412 37.0583 15.9819 37.3294 16.5262C37.1359 15.1366 37.2427 14.1584 37.719 13.0806C38.1001 12.2184 38.225 10.9478 38.2399 10.4202C38.2277 9.5001 37.8041 7.3955 36.2066 6.33805Z",
    fill: "url(#paint71_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3199 5.16855C49.6544 6.5574 49.0724 7.90033 48.9897 8.39819C48.9025 7.68348 48.4845 5.99414 47.5097 4.95449C46.5349 3.91483 46.0355 2.24946 45.8644 1.55823C45.8142 0.995447 46.2711 0.0948956 47.0676 0.247032C47.8642 0.399168 47.9929 1.21401 47.9577 1.60242C47.9092 1.92243 47.8426 2.73422 47.9642 3.42127C48.0859 4.10831 48.3767 4.98837 48.5069 5.34252C48.6662 5.82074 48.9856 7.10139 48.9897 8.39819C49.1447 7.10016 50.0195 5.46019 50.4376 4.80246C50.5637 4.62898 50.8974 4.14745 51.2236 3.60915C51.5498 3.07085 51.6772 2.2865 51.7002 1.96161C51.8011 1.50673 52.2084 0.644109 53.0297 0.832584C53.851 1.02106 53.819 2.02386 53.7004 2.5017C53.6009 2.81196 52.9854 3.7797 51.3199 5.16855Z",
    fill: "url(#paint72_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4797 3.34854C49.6708 4.74294 49.1942 6.51428 49.057 7.22566C49.1978 5.67203 48.9471 4.91293 48.7684 3.57487C48.6255 2.50442 48.7384 1.68567 48.7923 1.40621L48.8795 1.14627C49.5201 0.130649 50.296 0.389491 50.6039 0.645865C50.8996 0.965754 51.2887 1.95413 50.4797 3.34854Z",
    fill: "url(#paint73_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1404 82.8989C38.7856 81.4862 39.3479 80.135 39.4235 79.636C39.521 80.3494 39.9635 82.0325 40.9533 83.0581C41.9431 84.0836 42.4667 85.7416 42.6478 86.4303C42.7063 86.9923 42.2625 87.8993 41.4638 87.7587C40.6652 87.618 40.5246 86.8051 40.5541 86.4162C40.598 86.0955 40.6527 85.2829 40.5211 84.5976C40.3896 83.9124 40.0859 83.0367 39.9506 82.6844C39.7844 82.2085 39.4464 80.9326 39.4235 79.636C39.2873 80.9361 38.4364 82.5885 38.028 83.2522C37.9044 83.4275 37.5777 83.9138 37.2594 84.4567C36.9411 84.9997 36.8251 85.7858 36.8068 86.111C36.7125 86.5672 36.3178 87.4356 35.4939 87.259C34.6699 87.0824 34.6873 86.0792 34.799 85.5997C34.894 85.2881 35.4953 84.3116 37.1404 82.8989Z",
    fill: "url(#paint74_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.007 84.7066C38.7955 83.3007 39.2464 81.5227 39.3732 80.8094C39.255 82.3649 39.5167 83.1203 39.7148 84.4557C39.8733 85.5239 39.7723 86.3442 39.7225 86.6244L39.6391 86.8856C39.0133 87.9103 38.2337 87.6627 37.9221 87.4108C37.6218 87.0952 37.2184 86.1125 38.007 84.7066Z",
    fill: "url(#paint75_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1778 8.30982C59.2079 9.22238 58.2965 10.3697 58.087 10.8292C58.1887 10.1164 58.2243 8.377 57.5532 7.1217C56.882 5.8664 56.8328 4.12915 56.8473 3.41741C56.9451 2.86085 57.6207 2.10867 58.3505 2.46078C59.0803 2.81289 58.9927 3.63313 58.8577 3.99923C58.7276 4.29585 58.4522 5.06284 58.391 5.75779C58.3298 6.45275 58.3818 7.37773 58.4155 7.75335C58.4449 8.2563 58.4204 9.57559 58.087 10.8292C58.5744 9.61537 59.8459 8.25661 60.4208 7.72895C60.5877 7.59387 61.0353 7.2147 61.4904 6.77876C61.9455 6.34281 62.2726 5.61801 62.3792 5.3101C62.5951 4.89673 63.2128 4.16839 63.9571 4.56198C64.7014 4.95556 64.4097 5.91597 64.1708 6.34697C63.994 6.62102 63.1478 7.39726 61.1778 8.30982Z",
    fill: "url(#paint76_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8397 6.33543C59.6956 7.47398 58.7746 9.0622 58.457 9.71399C58.9971 8.24958 58.9524 7.45178 59.1278 6.11329C59.2681 5.0425 59.5901 4.28073 59.7149 4.02466L59.8667 3.79605C60.7496 2.98002 61.4318 3.4299 61.6626 3.75684C61.8649 4.14198 61.9837 5.19689 60.8397 6.33543Z",
    fill: "url(#paint77_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2653 79.7394C29.2218 78.7986 30.1164 77.6383 30.3191 77.1758C30.2278 77.89 30.2175 79.6298 30.9068 80.8753C31.5962 82.1208 31.6707 83.8571 31.6665 84.569C31.5768 85.1269 30.9123 85.8887 30.1774 85.5472C29.4425 85.2056 29.5182 84.3842 29.6479 84.0162C29.7736 83.7177 30.0379 82.9468 30.089 82.2511C30.1401 81.5553 30.0746 80.6312 30.0354 80.2561C29.9987 79.7536 30.004 78.4341 30.3191 77.1758C29.8495 78.3965 28.5978 79.7735 28.0307 80.3093C27.8658 80.4468 27.4237 80.8324 26.975 81.2749C26.5264 81.7173 26.2098 82.4467 26.1076 82.7562C25.8979 83.1726 25.2908 83.9097 24.5408 83.5269C23.7909 83.1441 24.0686 82.1796 24.3011 81.7452C24.474 81.4686 25.3088 80.6803 27.2653 79.7394Z",
    fill: "url(#paint78_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6321 81.7088C28.7595 80.5539 29.6574 78.9525 29.9654 78.2962C29.4467 79.7683 29.5029 80.5654 29.347 81.9062C29.2223 82.9789 28.9114 83.7453 28.7904 84.0031L28.6419 84.2339C27.771 85.0625 27.0823 84.6225 26.8468 84.2989C26.6389 83.9167 26.5048 82.8637 27.6321 81.7088Z",
    fill: "url(#paint79_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8831 13.8869C67.7429 14.261 66.5642 15.1345 66.2423 15.5244C66.526 14.8621 67.0127 13.1911 66.6909 11.8057C66.3691 10.4203 66.7734 8.7296 66.9725 8.04584C67.2117 7.53344 68.0599 6.98089 68.6733 7.50898C69.2867 8.03707 68.9887 8.8068 68.7631 9.12565C68.5603 9.37867 68.0948 10.0486 67.8549 10.7041C67.615 11.3596 67.4247 12.2665 67.3596 12.638C67.2572 13.1313 66.8904 14.3994 66.2423 15.5244C67.0288 14.4775 68.6104 13.4925 69.3029 13.1309C69.4993 13.0434 70.0302 12.7924 70.5832 12.4886C71.1361 12.1847 71.6406 11.5688 71.8237 11.2989C72.1397 10.9552 72.9258 10.4108 73.5424 10.9826C74.1589 11.5545 73.6274 12.4071 73.2846 12.7619C73.0425 12.981 72.0233 13.5129 69.8831 13.8869Z",
    fill: "url(#paint80_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0699 11.8927C68.6688 12.6978 67.366 13.9947 66.8898 14.5425C67.7923 13.2671 67.9566 12.485 68.4742 11.2373C68.8882 10.2391 69.3974 9.58621 69.5844 9.371L69.7906 9.18928C70.8556 8.62846 71.3976 9.23872 71.5354 9.61395C71.6307 10.0381 71.4711 11.0876 70.0699 11.8927Z",
    fill: "url(#paint81_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5486 74.1481C20.6831 73.7432 21.849 72.8529 22.1651 72.4583C21.8911 73.1246 21.4287 74.8025 21.7706 76.1831C22.1125 77.5637 21.7329 79.2601 21.5438 79.9466C21.312 80.4624 20.472 81.0271 19.851 80.5079C19.23 79.9887 19.5167 79.2148 19.7376 78.8927C19.9367 78.6368 20.3925 77.9603 20.6228 77.3014C20.8531 76.6425 21.0302 75.733 21.0899 75.3606C21.1851 74.8658 21.5334 73.5926 22.1651 72.4583C21.3939 73.5165 19.8268 74.5241 19.1397 74.8957C18.9446 74.986 18.4173 75.2446 17.8689 75.5564C17.3204 75.8682 16.8249 76.4912 16.6458 76.7638C16.3348 77.112 15.5567 77.6677 14.9319 77.1047C14.3071 76.5418 14.8261 75.6817 15.1638 75.322C15.4026 75.0994 16.414 74.5529 18.5486 74.1481Z",
    fill: "url(#paint82_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3907 76.1447C19.78 75.3196 21.0638 74.0041 21.532 73.4495C20.6481 74.7377 20.4952 75.5222 19.9958 76.7772C19.5963 77.7812 19.0967 78.4414 18.9128 78.6592L18.7093 78.8439C17.6526 79.42 17.1018 78.8176 16.9585 78.4444C16.857 78.0217 17.0014 76.9699 18.3907 76.1447Z",
    fill: "url(#paint83_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8424 21.5198C74.6778 21.3299 73.3121 21.87 72.8998 22.1638C73.346 21.5971 74.2508 20.1084 74.3003 18.6874C74.3498 17.2663 75.18 15.7373 75.5501 15.1281C75.9145 14.6948 76.8775 14.3795 77.3326 15.0476C77.7877 15.7157 77.2998 16.3824 76.9989 16.6323C76.7372 16.8245 76.1133 17.3517 75.7111 17.9231C75.309 18.4944 74.8893 19.3214 74.7297 19.6635C74.5025 20.1137 73.8184 21.244 72.8998 22.1638C73.9318 21.3551 75.7157 20.811 76.4786 20.6401C76.6911 20.6062 77.2692 20.5005 77.8823 20.3494C78.4955 20.1983 79.1429 19.7334 79.39 19.5198C79.7846 19.2692 80.6855 18.9458 81.1323 19.657C81.5792 20.3682 80.844 21.0548 80.4206 21.3092C80.1298 21.4585 79.0069 21.7097 76.8424 21.5198Z",
    fill: "url(#paint84_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5415 19.6417C75.9787 20.0585 74.3831 20.9756 73.7806 21.3821C74.9841 20.3826 75.3462 19.6695 76.1706 18.5976C76.8302 17.74 77.4918 17.2405 77.7285 17.0809L77.9748 16.9584C79.1494 16.691 79.5142 17.4201 79.5498 17.818C79.5315 18.2523 79.1043 19.2249 77.5415 19.6417Z",
    fill: "url(#paint85_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5842 66.5057C13.7513 66.6645 15.1091 66.1048 15.517 65.8051C15.0791 66.3781 14.1961 67.8797 14.1673 69.3013C14.1385 70.723 13.3306 72.2638 12.9693 72.8782C12.6113 73.3167 11.653 73.6458 11.1882 72.9844C10.7234 72.3229 11.2016 71.6492 11.4988 71.395C11.7577 71.1991 12.3738 70.663 12.7677 70.0859C13.1615 69.5088 13.5691 68.6758 13.7237 68.3315C13.9443 67.8781 14.6119 66.738 15.517 65.8051C14.4969 66.6286 12.7212 67.1983 11.9608 67.3801C11.7489 67.4171 11.1723 67.5311 10.5614 67.691C9.95056 67.851 9.30994 68.3252 9.06599 68.5423C8.67507 68.7985 7.77895 69.1349 7.32184 68.4302C6.86472 67.7255 7.58979 67.0284 8.00946 66.7679C8.29811 66.6144 9.41717 66.347 11.5842 66.5057Z",
    fill: "url(#paint86_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9125 68.3937C12.4691 67.9545 14.0512 67.0145 14.6477 66.5994C13.4589 67.6161 13.1071 68.3344 12.2984 69.4181C11.6514 70.285 10.9972 70.7939 10.7628 70.957L10.5183 71.083C9.34765 71.3673 8.97233 70.6436 8.93099 70.2462C8.94292 69.8117 9.35591 68.833 10.9125 68.3937Z",
    fill: "url(#paint87_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5815 30.6884C79.5401 29.9474 78.0804 30.1173 77.6058 30.2949C78.1842 29.8625 79.4453 28.6576 79.8627 27.2976C80.2801 25.9377 81.4796 24.6747 81.9956 24.1816C82.4603 23.8569 83.4724 23.8004 83.7383 24.5629C84.0042 25.3255 83.3594 25.8438 83.0038 26.0077C82.7011 26.1259 81.9613 26.4744 81.4242 26.9228C80.8871 27.3711 80.2667 28.0618 80.0236 28.3511C79.6871 28.7274 78.7323 29.6431 77.6058 30.2949C78.8129 29.7795 80.6775 29.7135 81.4589 29.7449C81.6729 29.7668 82.2589 29.8137 82.8904 29.8257C83.5219 29.8376 84.2682 29.5553 84.5625 29.4126C85.0088 29.2722 85.9631 29.1919 86.2097 29.9939C86.4564 30.7959 85.5677 31.2698 85.0926 31.4065C84.7728 31.4758 83.6229 31.4293 81.5815 30.6884Z",
    fill: "url(#paint88_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7453 29.0543C81.1273 29.0543 79.3475 29.5292 78.6598 29.7667C80.0823 29.1112 80.6176 28.5157 81.6927 27.6926C82.5527 27.0342 83.3217 26.7221 83.5919 26.6288L83.8617 26.574C85.0658 26.6183 85.2285 27.4164 85.1594 27.81C85.0288 28.2247 84.3632 29.0542 82.7453 29.0543Z",
    fill: "url(#paint89_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84698 57.3333C8.89894 58.0448 10.356 57.8539 10.828 57.6695C10.2559 58.1102 9.01245 59.3332 8.61489 60.6989C8.21733 62.0647 7.03624 63.3449 6.52747 63.8454C6.06762 64.1768 5.05637 64.2478 4.77944 63.4892C4.50251 62.7306 5.13966 62.203 5.49286 62.034C5.79384 61.9114 6.52844 61.5523 7.05896 61.0963C7.58948 60.6403 8.19982 59.9407 8.43867 59.6479C8.76972 59.2668 9.71106 58.3375 10.828 57.6695C9.62848 58.2022 7.76504 58.2951 6.98326 58.2749C6.76894 58.2561 6.18239 58.2176 5.55074 58.2148C4.9191 58.2119 4.17697 58.505 3.88486 58.6519C3.44061 58.7987 2.48756 58.8928 2.2293 58.0944C1.97103 57.296 2.8527 56.8093 3.32582 56.6658C3.64456 56.5919 4.79502 56.6219 6.84698 57.3333Z",
    fill: "url(#paint90_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70707 58.984C7.32485 58.9606 9.09758 58.4602 9.78173 58.2128C8.36895 58.8887 7.84238 59.4919 6.77937 60.3303C5.92895 61.0011 5.16461 61.3242 4.89584 61.4214L4.62685 61.4801C3.4222 61.4532 3.24789 60.6574 3.31132 60.2629C3.43583 59.8463 4.0893 59.0073 5.70707 58.984Z",
    fill: "url(#paint91_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7774 40.7676C81.9983 39.5261 80.5442 39.3143 80.0395 39.3636C80.7107 39.0949 82.2422 38.2558 82.9991 37.0498C83.7559 35.8437 85.2431 34.9326 85.8698 34.5892C86.403 34.3953 87.3954 34.6014 87.4539 35.4064C87.5124 36.2115 86.7548 36.5461 86.3687 36.6128C86.0455 36.649 85.2403 36.7951 84.6049 37.0898C83.9695 37.3846 83.1906 37.8919 82.8805 38.1087C82.4576 38.3856 81.2972 39.0241 80.0395 39.3636C81.3396 39.1767 83.1578 39.5932 83.9044 39.8247C84.1054 39.9011 84.6592 40.0973 85.2661 40.2715C85.873 40.4457 86.6674 40.3652 86.9886 40.3031C87.4563 40.2825 88.399 40.4507 88.4286 41.2889C88.4582 42.1271 87.4766 42.356 86.9821 42.3656C86.6552 42.3502 85.5566 42.0091 83.7774 40.7676Z",
    fill: "url(#paint92_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3266 39.489C83.7637 39.0723 81.921 39.0726 81.195 39.1249C82.7395 38.8581 83.4114 38.4207 84.664 37.9026C85.666 37.4881 86.4899 37.3848 86.7751 37.3642L87.05 37.3808C88.2016 37.7337 88.1512 38.5465 87.982 38.9089C87.748 39.2759 86.8894 39.9057 85.3266 39.489Z",
    fill: "url(#paint93_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65957 47.2559C6.45657 48.4716 7.91361 48.6625 8.4175 48.6059C7.75032 48.8843 6.23113 49.7453 5.49191 50.9622C4.75268 52.179 3.27887 53.1114 2.65728 53.4638C2.12691 53.6654 1.13164 53.4736 1.06146 52.6695C0.991267 51.8654 1.74393 51.5199 2.12903 51.4476C2.45163 51.4068 3.25461 51.2491 3.88565 50.9452C4.5167 50.6414 5.28818 50.1229 5.59504 49.9016C6.01394 49.6187 7.1649 48.9635 8.4175 48.6059C7.12032 48.8116 5.29622 48.4213 4.54631 48.2005C4.3442 48.1271 3.78763 47.9389 3.17825 47.7735C2.56887 47.608 1.77581 47.6999 1.45545 47.7666C0.988155 47.794 0.0431088 47.6394 0.00129861 46.8017C-0.0405115 45.9639 0.937678 45.721 1.432 45.7042C1.7591 45.7149 2.86256 46.0402 4.65957 47.2559Z",
    fill: "url(#paint94_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1292 48.5567C4.69792 48.9508 6.54041 48.924 7.26557 48.8613C5.72516 49.1503 5.05965 49.5973 3.81479 50.1334C2.81891 50.5622 1.99657 50.6775 1.71169 50.7021L1.4366 50.6895C0.279994 50.3532 0.318579 49.5397 0.482447 49.175C0.711062 48.8047 1.56047 48.1626 3.1292 48.5567Z",
    fill: "url(#paint95_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2805 51.0708C81.8849 49.4134 80.5354 48.8343 80.0351 48.7519C80.7533 48.6652 82.4509 48.2492 83.4956 47.2791C84.5404 46.3091 86.2139 45.8121 86.9085 45.6419C87.474 45.5918 88.3789 46.0465 88.2261 46.8392C88.0732 47.6319 87.2544 47.76 86.8641 47.7249C86.5425 47.6767 85.7267 47.6104 85.0363 47.7315C84.3459 47.8525 83.4616 48.1419 83.1057 48.2715C82.6252 48.43 81.3382 48.7479 80.0351 48.7519C81.3395 48.9062 82.9875 49.7768 83.6484 50.1928C83.8227 50.3183 84.3066 50.6504 84.8475 50.975C85.3885 51.2996 86.1767 51.4264 86.5031 51.4492C86.9602 51.5497 87.827 51.955 87.6376 52.7723C87.4482 53.5896 86.4406 53.5578 85.9604 53.4398C85.6486 53.3407 84.6762 52.7282 83.2805 51.0708Z",
    fill: "url(#paint96_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1094 50.2347C83.7082 49.4297 81.9282 48.9554 81.2134 48.8189C82.7746 48.959 83.5374 48.7096 84.882 48.5318C85.9577 48.3895 86.7804 48.5018 87.0612 48.5555L87.3224 48.6423C88.343 49.2797 88.0829 50.0519 87.8253 50.3583C87.5038 50.6526 86.5106 51.0397 85.1094 50.2347Z",
    fill: "url(#paint97_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17109 36.9602C6.59067 38.5973 7.94843 39.157 8.44986 39.2321C7.733 39.3292 6.04165 39.7696 5.01113 40.7546C3.98062 41.7395 2.31453 42.2606 1.62247 42.4408C1.05773 42.499 0.14627 42.0574 0.287607 41.2626C0.428945 40.4678 1.24582 40.3279 1.63659 40.3573C1.95883 40.4009 2.77546 40.4554 3.46402 40.3245C4.15258 40.1935 5.03263 39.8914 5.38659 39.7567C5.86479 39.5913 7.14693 39.2549 8.44986 39.2321C7.1434 39.0966 5.48294 38.2499 4.81602 37.8434C4.63989 37.7205 4.15123 37.3953 3.60564 37.0786C3.06005 36.7618 2.27011 36.6463 1.94334 36.6282C1.48483 36.5343 0.612198 36.1416 0.789689 35.3216C0.96718 34.5017 1.97523 34.5189 2.45706 34.6301C2.77025 34.7246 3.75151 35.323 5.17109 36.9602Z",
    fill: "url(#paint98_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35455 37.8225C4.76731 38.6072 6.554 39.0559 7.27075 39.1821C5.70768 39.0645 4.94858 39.3249 3.60672 39.522C2.53323 39.6798 1.70894 39.5793 1.42736 39.5297L1.16492 39.4467C0.135185 38.824 0.384034 38.0481 0.637177 37.738C0.954315 37.4392 1.94178 37.0378 3.35455 37.8225Z",
    fill: "url(#paint99_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1239 60.8809C79.2069 58.9205 78.0541 58.0135 77.5922 57.8051C78.3085 57.9063 80.0564 57.9417 81.3179 57.2738C82.5793 56.6059 84.325 56.5569 85.0402 56.5713C85.5995 56.6687 86.3553 57.341 86.0015 58.0672C85.6477 58.7935 84.8234 58.7064 84.4556 58.572C84.1575 58.4426 83.3868 58.1685 82.6884 58.1076C81.9901 58.0466 81.0606 58.0984 80.6831 58.132C80.1777 58.1612 78.852 58.1369 77.5922 57.8051C78.812 58.2901 80.1774 59.5555 80.7076 60.1275C80.8434 60.2936 81.2244 60.7391 81.6625 61.1919C82.1005 61.6448 82.8289 61.9703 83.1383 62.0764C83.5537 62.2912 84.2856 62.9059 83.8901 63.6466C83.4946 64.3873 82.5295 64.0971 82.0964 63.8594C81.821 63.6834 81.0409 62.8413 80.1239 60.8809Z",
    fill: "url(#paint100_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.108 60.5444C80.9639 59.4059 79.3679 58.4893 78.7129 58.1733C80.1845 58.7107 80.9862 58.6663 82.3312 58.8408C83.4072 58.9805 84.1727 59.3009 84.43 59.425L84.6597 59.5761C85.4797 60.4547 85.0277 61.1336 84.6991 61.3632C84.3121 61.5646 83.252 61.6828 82.108 60.5444Z",
    fill: "url(#paint101_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3459 27.133C9.29131 29.08 10.4573 29.9703 10.9221 30.172C10.2044 30.0811 8.45613 30.0709 7.20455 30.7569C5.95297 31.4429 4.20814 31.517 3.49279 31.5129C2.93216 31.4236 2.16662 30.7623 2.50985 30.031C2.85308 29.2997 3.6785 29.375 4.0483 29.504C4.34822 29.6291 5.12285 29.8921 5.82201 29.943C6.52117 29.9938 7.44981 29.9286 7.82674 29.8897C8.33166 29.8531 9.65761 29.8584 10.9221 30.172C9.69535 29.7046 8.3117 28.4591 7.77321 27.8947C7.63506 27.7305 7.24761 27.2906 6.803 26.8441C6.35839 26.3976 5.62539 26.0827 5.31447 25.981C4.89601 25.7722 4.15526 25.1681 4.53995 24.4218C4.92465 23.6755 5.89386 23.9518 6.33037 24.1832C6.60829 24.3552 7.40048 25.186 8.3459 27.133Z",
    fill: "url(#paint102_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36698 27.4981C7.52751 28.6199 9.13664 29.5135 9.79614 29.82C8.31692 29.3038 7.51596 29.3598 6.16854 29.2046C5.09061 29.0805 4.32054 28.7711 4.06145 28.6507L3.82955 28.5029C2.99685 27.6362 3.43901 26.9509 3.76417 26.7166C4.14822 26.5096 5.20645 26.3762 6.36698 27.4981Z",
    fill: "url(#paint103_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5196 69.5439C74.1437 67.4141 73.266 66.2411 72.8741 65.9208C73.5397 66.203 75.2188 66.6875 76.611 66.3672C78.0031 66.047 79.7021 66.4492 80.3892 66.6474C80.9041 66.8855 81.4594 67.7295 80.9287 68.3399C80.398 68.9503 79.6245 68.6538 79.3041 68.4293C79.0499 68.2275 78.3767 67.7643 77.718 67.5255C77.0593 67.2868 76.148 67.0975 75.7747 67.0326C75.2789 66.9307 74.0047 66.5657 72.8741 65.9208C73.9262 66.7034 74.916 68.2774 75.2794 68.9665C75.3673 69.1619 75.6194 69.6903 75.9248 70.2406C76.2302 70.7908 76.8491 71.2928 77.1203 71.4751C77.4657 71.7895 78.0128 72.5718 77.4381 73.1854C76.8634 73.7989 76.0067 73.27 75.6502 72.9288C75.4299 72.6879 74.8955 71.6737 74.5196 69.5439Z",
    fill: "url(#paint104_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5235 69.7298C75.7145 68.3354 74.4113 67.039 73.8609 66.5651C75.1425 67.4633 75.9284 67.6268 77.1822 68.1418C78.1853 68.5538 78.8413 69.0605 79.0576 69.2467L79.2402 69.4518C79.8037 70.5117 79.1905 71.051 78.8134 71.1882C78.3872 71.283 77.3326 71.1242 76.5235 69.7298Z",
    fill: "url(#paint105_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9645 18.4586C14.3714 20.5827 15.266 21.743 15.6625 22.0576C14.9929 21.7849 13.3069 21.3247 11.9196 21.665C10.5322 22.0053 8.82757 21.6275 8.13767 21.4392C7.61936 21.2086 7.0519 20.3726 7.57364 19.7547C8.09537 19.1367 8.87309 19.422 9.19672 19.6419C9.45388 19.84 10.1337 20.2935 10.7958 20.5227C11.4579 20.7519 12.3719 20.9282 12.7461 20.9876C13.2433 21.0824 14.5227 21.429 15.6625 22.0576C14.5992 21.2902 13.5866 19.7306 13.2133 19.0468C13.1225 18.8527 12.8627 18.328 12.5493 17.7822C12.236 17.2364 11.6099 16.7433 11.336 16.565C10.9861 16.2556 10.4277 15.4812 10.9934 14.8595C11.5591 14.2377 12.4234 14.7542 12.7849 15.0902C13.0086 15.3279 13.5577 16.3344 13.9645 18.4586Z",
    fill: "url(#paint106_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9581 18.3015C12.7873 19.6841 14.1092 20.9616 14.6665 21.4275C13.372 20.5479 12.5837 20.3957 11.3226 19.8988C10.3137 19.5013 9.6503 19.0041 9.43136 18.821L9.24579 18.6186C8.66688 17.5669 9.27221 17.0188 9.64724 16.8763C10.072 16.7753 11.1289 16.9189 11.9581 18.3015Z",
    fill: "url(#paint107_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8495 76.4694C67.0403 74.3153 66.4976 72.9562 66.2024 72.5459C66.7719 72.99 68.2678 73.8904 69.6958 73.9396C71.1238 73.9888 72.6603 74.815 73.2724 75.1834C73.7079 75.546 74.0247 76.5043 73.3533 76.9572C72.682 77.4101 72.012 76.9245 71.7609 76.6251C71.5678 76.3647 71.038 75.7439 70.4638 75.3436C69.8897 74.9434 69.0587 74.5257 68.715 74.367C68.2626 74.1408 67.1267 73.4601 66.2024 72.5459C67.0151 73.5729 67.5618 75.3481 67.7335 76.1074C67.7676 76.3188 67.8738 76.8941 68.0256 77.5043C68.1775 78.1144 68.6447 78.7587 68.8593 79.0046C69.1111 79.3973 69.4361 80.2938 68.7215 80.7385C68.0068 81.1831 67.3168 80.4516 67.0612 80.0302C66.9111 79.7408 66.6587 78.6234 66.8495 76.4694Z",
    fill: "url(#paint108_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7368 77.1651C68.318 75.6099 67.3964 74.022 66.9879 73.4224C67.9923 74.6201 68.7089 74.9805 69.786 75.8009C70.6477 76.4572 71.1497 77.1156 71.3101 77.3511L71.4332 77.5963C71.7019 78.7652 70.9693 79.1282 70.5694 79.1636C70.133 79.1454 69.1556 78.7203 68.7368 77.1651Z",
    fill: "url(#paint109_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6441 11.528C21.4846 13.6846 22.0471 15.0357 22.3482 15.4417C21.7724 15.0059 20.2635 14.1272 18.8349 14.0985C17.4063 14.0699 15.858 13.2659 15.2406 12.9064C14.7999 12.5501 14.4692 11.5965 15.1339 11.1339C15.7986 10.6714 16.4756 11.1473 16.731 11.443C16.9279 11.7006 17.4666 12.3138 18.0465 12.7057C18.6265 13.0977 19.4635 13.5033 19.8095 13.6571C20.2651 13.8767 21.4107 14.541 22.3482 15.4417C21.5207 14.4266 20.9482 12.6594 20.7655 11.9027C20.7283 11.6919 20.6138 11.1181 20.4531 10.5102C20.2924 9.90229 19.8158 9.26477 19.5977 9.02201C19.3402 8.63299 19.0022 7.74122 19.7103 7.28633C20.4184 6.83143 21.119 7.55298 21.3807 7.97061C21.535 8.25786 21.8036 9.37148 21.6441 11.528Z",
    fill: "url(#paint110_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7469 10.8595C20.1883 12.4086 21.1329 13.983 21.55 14.5767C20.5283 13.3936 19.8066 13.0435 18.7176 12.2387C17.8465 11.5949 17.335 10.9438 17.1711 10.7106L17.0445 10.4672C16.7589 9.30231 17.4861 8.9288 17.8855 8.88767C18.322 8.89953 19.3055 9.31052 19.7469 10.8595Z",
    fill: "url(#paint111_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6363 81.1855C58.3808 79.154 58.2101 77.7014 58.0316 77.2291C58.4662 77.8047 59.677 79.0597 61.0435 79.475C62.4101 79.8904 63.6793 81.0841 64.1748 81.5976C64.5011 82.06 64.5579 83.0672 63.7916 83.3318C63.0253 83.5964 62.5044 82.9548 62.3398 82.6009C62.221 82.2996 61.8708 81.5635 61.4202 81.029C60.9697 80.4945 60.2757 79.8771 59.9849 79.6352C59.6068 79.3002 58.6866 78.3501 58.0316 77.2291C58.5495 78.4303 58.6159 80.2859 58.5843 81.0635C58.5623 81.2765 58.5152 81.8596 58.5032 82.488C58.4912 83.1165 58.7749 83.8592 58.9182 84.152C59.0593 84.5962 59.1401 85.5458 58.3341 85.7913C57.5282 86.0367 57.052 85.1524 56.9146 84.6795C56.8449 84.3613 56.8917 83.217 57.6363 81.1855Z",
    fill: "url(#paint112_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2783 82.3436C59.2783 80.7335 58.801 78.9623 58.5624 78.278C59.2211 79.6936 59.8196 80.2262 60.6466 81.2961C61.3083 82.152 61.6218 82.9172 61.7156 83.1861L61.7707 83.4546C61.7262 84.6529 60.9241 84.8148 60.5287 84.746C60.1119 84.6161 59.2784 83.9537 59.2783 82.3436Z",
    fill: "url(#paint113_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8613 6.81374C30.1463 8.85574 30.3382 10.3057 30.5235 10.7754C30.0806 10.2062 28.8517 8.9687 27.4793 8.57307C26.1068 8.17744 24.8203 7.00208 24.3175 6.49578C23.9845 6.03816 23.9131 5.03183 24.6754 4.75624C25.4377 4.48065 25.9679 5.11471 26.1377 5.46619C26.2609 5.76572 26.6217 6.49675 27.08 7.02469C27.5382 7.55264 28.2412 8.16001 28.5354 8.3977C28.9184 8.72715 29.8522 9.66392 30.5235 10.7754C29.9882 9.58174 29.8949 7.72735 29.9151 6.94936C29.934 6.73608 29.9727 6.15238 29.9755 5.5238C29.9784 4.89522 29.6839 4.15669 29.5363 3.866C29.3888 3.42391 29.2942 2.47548 30.0965 2.21847C30.8988 1.96147 31.3878 2.83886 31.5321 3.30968C31.6064 3.62687 31.5762 4.77174 30.8613 6.81374Z",
    fill: "url(#paint114_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2026 5.67937C29.226 7.28929 29.729 9.05342 29.9775 9.73424C29.2983 8.32833 28.6922 7.80431 27.8496 6.74646C27.1756 5.90017 26.8509 5.13954 26.7533 4.87207L26.6943 4.60439C26.7214 3.40559 27.521 3.23212 27.9174 3.29524C28.336 3.41915 29.1791 4.06944 29.2026 5.67937Z",
    fill: "url(#paint115_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5078 83.3707C48.7554 81.6002 48.9682 80.1532 48.9187 79.651C49.1888 80.3189 50.0319 81.843 51.2438 82.5962C52.4558 83.3493 53.3713 84.8293 53.7164 85.4529C53.9113 85.9836 53.7042 86.9711 52.8952 87.0293C52.0862 87.0876 51.75 86.3336 51.6829 85.9494C51.6465 85.6278 51.4997 84.8265 51.2036 84.1942C50.9074 83.5619 50.3976 82.7867 50.1797 82.4782C49.9015 82.0573 49.2598 80.9025 48.9187 79.651C49.1065 80.9447 48.688 82.7541 48.4553 83.4971C48.3786 83.6972 48.1815 84.2482 48.0064 84.8522C47.8314 85.4562 47.9123 86.2466 47.9746 86.5664C47.9954 87.0317 47.8263 87.9699 46.984 87.9993C46.1417 88.0288 45.9117 87.052 45.902 86.5599C45.9175 86.2345 46.2603 85.1412 47.5078 83.3707Z",
    fill: "url(#paint116_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7927 84.9123C49.2114 83.3571 49.2111 81.5234 49.1586 80.8009C49.4267 82.3378 49.8662 83.0065 50.3868 84.253C50.8033 85.2501 50.9072 86.07 50.9278 86.3539L50.9112 86.6274C50.5566 87.7734 49.7397 87.7232 49.3757 87.5549C49.0069 87.3221 48.374 86.4676 48.7927 84.9123Z",
    fill: "url(#paint117_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9879 4.63695C39.7662 6.42522 39.5744 7.87519 39.6312 8.37664C39.3515 7.71269 38.4863 6.20088 37.2635 5.46525C36.0407 4.72961 35.1038 3.26295 34.7497 2.64438C34.5471 2.11658 34.7399 1.12615 35.5479 1.0563C36.3559 0.986455 36.7031 1.73546 36.7757 2.11869C36.8168 2.43973 36.9752 3.23881 37.2806 3.86679C37.5859 4.49477 38.1069 5.26251 38.3293 5.56787C38.6136 5.98474 39.2719 7.13011 39.6312 8.37664C39.4246 7.08575 39.8168 5.27051 40.0387 4.52424C40.1124 4.32311 40.3015 3.76924 40.4678 3.16282C40.6341 2.5564 40.5417 1.76719 40.4747 1.44839C40.4472 0.983359 40.6025 0.0428995 41.4443 0.0012923C42.2861 -0.0403149 42.5303 0.933126 42.5471 1.42505C42.5364 1.75056 42.2095 2.84867 40.9879 4.63695Z",
    fill: "url(#paint118_radial_550_14846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6807 3.114C39.2847 4.67511 39.3116 6.50866 39.3746 7.2303C39.0843 5.69737 38.635 5.03508 38.0964 3.79627C37.6654 2.80522 37.5496 1.98688 37.5249 1.70338L37.5375 1.42963C37.8754 0.278635 38.6929 0.317032 39.0594 0.480105C39.4315 0.70761 40.0768 1.5529 39.6807 3.114Z",
    fill: "url(#paint119_radial_550_14846)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_550_14846_clip_path",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9324 13.4572C48.7483 13.5827 50.308 14.3636 50.0195 16.4825C49.8213 17.9382 49.1216 18.5921 48.4659 19.2049C47.9286 19.707 47.4209 20.1815 47.2431 21.047C47.2241 20.1638 46.8102 19.6064 46.372 19.0165C45.8374 18.2967 45.2668 17.5285 45.3341 16.0611C45.432 13.925 47.1071 13.4351 47.9324 13.4572Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1754 72.3164C39.375 72.1152 37.8958 71.192 38.383 69.1094C38.7177 67.6787 39.476 67.093 40.1865 66.5443C40.7689 66.0945 41.3191 65.6695 41.5777 64.8245C41.5133 65.7055 41.8729 66.2992 42.2534 66.9274C42.7178 67.694 43.2133 68.5121 43.0079 69.9667C42.7089 72.0842 40.995 72.4155 40.1754 72.3164Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4833 15.4587C56.2387 15.7902 57.5422 16.9462 56.7124 18.9186C56.1423 20.2736 55.2964 20.725 54.5037 21.148C53.8541 21.4946 53.2403 21.8222 52.8434 22.6124C53.0548 21.7544 52.7999 21.1094 52.5301 20.4267C52.2009 19.5938 51.8496 18.7048 52.2962 17.3047C52.9464 15.2667 54.6918 15.2249 55.4833 15.4587Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6824 70.3145C31.9615 69.9139 30.7729 68.6413 31.7851 66.7551C32.4804 65.4594 33.3653 65.089 34.1943 64.7419C34.8738 64.4575 35.5158 64.1887 35.9854 63.4391C35.694 64.2735 35.887 64.9395 36.0912 65.6443C36.3403 66.5044 36.6062 67.4222 36.0294 68.7744C35.1899 70.7427 33.4482 70.6213 32.6824 70.3145Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2561 19.322C62.8996 19.8368 63.858 21.2891 62.5435 22.9805C61.6405 24.1425 60.706 24.3607 59.8303 24.5651C59.1126 24.7327 58.4345 24.891 57.8457 25.552C58.273 24.7777 58.1946 24.089 58.1115 23.3601C58.0102 22.4708 57.9021 21.5216 58.6976 20.2842C59.8557 18.4831 61.5525 18.8923 62.2561 19.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9652 66.436C25.3731 65.8634 24.5559 64.328 26.0242 62.7668C27.0329 61.6943 27.9839 61.5644 28.8749 61.4427C29.6052 61.3429 30.2953 61.2487 30.9439 60.6456C30.4454 61.3765 30.4585 62.0695 30.4724 62.8029C30.4894 63.6978 30.5075 64.6529 29.5988 65.8105C28.2759 67.4955 26.6252 66.9296 25.9652 66.436Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7895 24.7838C68.2772 25.4467 68.8252 27.0964 67.1156 28.3916C65.9411 29.2815 64.9817 29.2515 64.0827 29.2234C63.3459 29.2004 62.6497 29.1786 61.9091 29.6655C62.5232 29.0277 62.6265 28.3422 62.7359 27.6168C62.8693 26.7316 63.0117 25.7869 64.102 24.7967C65.689 23.3552 67.2216 24.1875 67.7895 24.7838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4817 60.9451C20.0587 60.2396 19.6687 58.546 21.493 57.4162C22.7462 56.64 23.6986 56.7595 24.591 56.8715C25.3223 56.9632 26.0134 57.0499 26.7967 56.6344C26.1251 57.212 25.9576 57.8848 25.7802 58.5968C25.5639 59.4656 25.333 60.3928 24.1541 61.2768C22.4381 62.5637 20.9908 61.5919 20.4817 60.9451Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7063 31.4718C72.005 32.2377 72.1052 33.9723 70.117 34.7831C68.7511 35.3401 67.8322 35.0641 66.9711 34.8054C66.2654 34.5934 65.5986 34.3931 64.7566 34.6726C65.5157 34.2147 65.7937 33.5792 66.088 32.9066C66.4471 32.086 66.8304 31.2102 68.1411 30.5344C70.0489 29.5508 71.3128 30.7495 71.7063 31.4718Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6055 54.2162C16.3805 53.4258 16.4443 51.6895 18.5002 51.068C19.9126 50.6411 20.8015 51.0018 21.6343 51.3397C22.3169 51.6167 22.9618 51.8785 23.8265 51.6788C23.0276 52.0638 22.6908 52.6705 22.3343 53.3126C21.8994 54.0961 21.4352 54.9322 20.0666 55.4825C18.0744 56.2835 16.9291 54.9721 16.6055 54.2162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7395 38.9302C73.8288 39.747 73.4746 41.4483 71.3432 41.7194C69.879 41.9056 69.0631 41.4022 68.2987 40.9306C67.6722 40.5441 67.0802 40.1789 66.1942 40.232C67.0465 39.9852 67.4804 39.443 67.9396 38.8691C68.4999 38.1689 69.0978 37.4217 70.5396 37.1065C72.6383 36.6478 73.5473 38.1312 73.7395 38.9302Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6009 46.7078C14.5891 45.8863 15.1023 44.2256 17.2498 44.1548C18.7251 44.1062 19.4899 44.6836 20.2064 45.2245C20.7937 45.6679 21.3486 46.0868 22.2358 46.1167C21.3639 46.2828 20.8808 46.7821 20.3695 47.3105C19.7456 47.9552 19.0798 48.6433 17.6147 48.8224C15.482 49.083 14.7169 47.5212 14.6009 46.7078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7507 46.6508C73.6245 47.4628 72.8398 49.0149 70.7106 48.7277C69.2478 48.5305 68.5907 47.8342 67.975 47.1817C67.4703 46.647 66.9935 46.1417 66.1238 45.9648C67.0113 45.946 67.5714 45.534 68.1642 45.098C68.8875 44.5659 69.6595 43.9981 71.1341 44.0651C73.2805 44.1626 73.7728 45.8295 73.7507 46.6508Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6044 38.9315C14.8066 38.1349 15.7342 36.663 17.827 37.1478C19.2647 37.4808 19.8532 38.2355 20.4047 38.9426C20.8566 39.5221 21.2836 40.0696 22.1328 40.327C21.2475 40.2629 20.651 40.6207 20.0197 40.9994C19.2493 41.4615 18.4272 41.9547 16.9655 41.7503C14.8377 41.4527 14.5048 39.7471 14.6044 38.9315Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7394 54.165C71.4063 54.9168 70.2447 56.2139 68.2627 55.3882C66.9011 54.8209 66.4474 53.979 66.0224 53.1902C65.674 52.5437 65.3448 51.9329 64.5508 51.538C65.4129 51.7484 66.0611 51.4947 66.7471 51.2262C67.5841 50.8986 68.4775 50.549 69.8844 50.9935C71.9324 51.6405 71.9744 53.3774 71.7394 54.165Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6161 31.4748C17.0186 30.7575 18.2974 29.5747 20.1928 30.5819C21.4949 31.2739 21.8671 32.1544 22.2159 32.9795C22.5017 33.6556 22.7718 34.2945 23.525 34.7619C22.6866 34.4719 22.0173 34.6639 21.309 34.8671C20.4448 35.115 19.5224 35.3797 18.1636 34.8057C16.1857 33.9702 16.3078 32.237 16.6161 31.4748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8573 60.9051C67.34 61.5454 65.8806 62.4991 64.1809 61.191C63.0132 60.2924 62.794 59.3624 62.5886 58.491C62.4202 57.7768 62.2612 57.102 61.5969 56.516C62.3749 56.9413 63.067 56.8632 63.7994 56.7806C64.6932 56.6797 65.647 56.5721 66.8903 57.3638C68.7003 58.5162 68.2891 60.2048 67.8573 60.9051Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5135 24.7903C21.0889 24.2011 22.6318 23.3879 24.2006 24.8491C25.2784 25.8528 25.4089 26.7992 25.5312 27.686C25.6314 28.4127 25.7261 29.0994 26.3322 29.7448C25.5977 29.2488 24.9013 29.2618 24.1643 29.2757C23.265 29.2926 22.3053 29.3106 21.1421 28.4063C19.4489 27.0898 20.0176 25.4471 20.5135 24.7903Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3689 66.4116C61.7027 66.8969 60.045 67.4422 58.7434 65.7409C57.8493 64.5721 57.8794 63.6174 57.9076 62.7227C57.9307 61.9895 57.9526 61.2967 57.4633 60.5597C58.1043 61.1708 58.7931 61.2736 59.5221 61.3825C60.4115 61.5152 61.3608 61.657 62.3559 62.7419C63.8045 64.3213 62.9681 65.8464 62.3689 66.4116Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0311 19.3334C26.7401 18.9125 28.442 18.5244 29.5773 20.3398C30.3572 21.587 30.2372 22.5347 30.1247 23.4228C30.0325 24.1506 29.9454 24.8383 30.3629 25.6178C29.7825 24.9494 29.1064 24.7827 28.3909 24.6063C27.5179 24.391 26.5862 24.1612 25.6978 22.9881C24.4047 21.2804 25.3812 19.8401 26.0311 19.3334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6483 70.3093C54.8786 70.6065 53.1355 70.7063 52.3208 68.7277C51.7611 67.3685 52.0385 66.454 52.2984 65.5971C52.5114 64.8949 52.7127 64.2313 52.4318 63.3933C52.892 64.1487 53.5306 64.4255 54.2064 64.7183C55.0311 65.0757 55.9111 65.4571 56.5902 66.7614C57.5786 68.66 56.3741 69.9178 55.6483 70.3093Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7929 15.4761C33.5872 15.2521 35.332 15.3156 35.9565 17.3616C36.3855 18.7671 36.023 19.6516 35.6834 20.4804C35.405 21.1597 35.142 21.8015 35.3426 22.662C34.9558 21.867 34.3461 21.5318 33.7009 21.1771C32.9136 20.7442 32.0734 20.2823 31.5204 18.9203C30.7155 16.9378 32.0333 15.7981 32.7929 15.4761Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1535 72.3327C47.3327 72.4215 45.6231 72.069 45.3507 69.948C45.1636 68.4909 45.6694 67.679 46.1433 66.9183C46.5317 66.2948 46.8987 65.7057 46.8453 64.8239C47.0933 65.6721 47.6382 66.1039 48.2148 66.5609C48.9184 67.1184 49.6694 67.7135 49.986 69.1483C50.447 71.2368 48.9564 72.1414 48.1535 72.3327Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3379 13.4812C41.1634 13.4694 42.8322 13.9801 42.9033 16.1172C42.9522 17.5853 42.372 18.3464 41.8284 19.0595C41.3829 19.6439 40.9619 20.1961 40.9319 21.079C40.765 20.2113 40.2632 19.7306 39.7323 19.2218C39.0844 18.6009 38.3929 17.9383 38.213 16.4803C37.9511 14.358 39.5205 13.5966 40.3379 13.4812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2681 30.3791C45.4607 28.5783 46.1531 26.4313 46.1531 24.1262C46.1531 21.8211 45.4607 19.6741 44.2681 17.8733C43.0755 19.6741 42.383 21.8211 42.383 24.1262C42.383 26.4313 43.0755 28.5783 44.2681 30.3791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2681 67.8967C45.4607 66.0959 46.1531 63.9489 46.1531 61.6438C46.1531 59.3387 45.4607 57.1917 44.2681 55.3909C43.0755 57.1917 42.383 59.3387 42.383 61.6438C42.383 63.9489 43.0755 66.0959 44.2681 67.8967Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5206 30.8052C49.1409 29.3729 50.3682 27.4775 50.9677 25.2509C51.5672 23.0243 51.4568 20.7722 50.7732 18.7255C49.1528 20.1578 47.9256 22.0533 47.3261 24.2799C46.7266 26.5064 46.837 28.7586 47.5206 30.8052Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.763 67.0444C39.3833 65.6121 40.6106 63.7167 41.2101 61.4901C41.8096 59.2635 41.6991 57.0114 41.0155 54.9647C39.3952 56.397 38.168 58.2925 37.5685 60.5191C36.969 62.7457 37.0794 64.9978 37.763 67.0444Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5515 32.0546C52.4892 31.0884 54.1676 29.5736 55.3257 27.5773C56.4839 25.581 56.963 23.3772 56.835 21.2242C54.8973 22.1904 53.2189 23.7052 52.0608 25.7015C50.9026 27.6977 50.4235 29.9016 50.5515 32.0546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7012 64.5458C33.6389 63.5796 35.3172 62.0648 36.4754 60.0685C37.6336 58.0723 38.1127 55.8684 37.9847 53.7154C36.047 54.6816 34.3686 56.1964 33.2105 58.1927C32.0523 60.1889 31.5732 62.3928 31.7012 64.5458Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1542 34.042C55.2771 33.6078 57.2923 32.5769 58.9302 30.9469C60.5681 29.317 61.604 27.3116 62.0403 25.199C59.9175 25.6332 57.9023 26.6641 56.2644 28.2941C54.6265 29.924 53.5905 31.9294 53.1542 34.042Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4958 60.5709C28.6187 60.1368 30.6339 59.1059 32.2718 57.4759C33.9097 55.846 34.9456 53.8406 35.3819 51.728C33.2591 52.1622 31.2439 53.1931 29.606 54.823C27.9681 56.453 26.9321 58.4584 26.4958 60.5709Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1513 36.632C57.3148 36.7594 59.5294 36.2827 61.5355 35.1301C63.5415 33.9776 65.0637 32.3074 66.0345 30.3791C63.8711 30.2517 61.6564 30.7285 59.6504 31.881C57.6444 33.0336 56.1222 34.7038 55.1513 36.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5016 55.3908C24.6651 55.5182 26.8797 55.0415 28.8858 53.889C30.8918 52.7364 32.414 51.0662 33.3848 49.1379C31.2214 49.0106 29.0067 49.4873 27.0007 50.6398C24.9947 51.7924 23.4725 53.4626 22.5016 55.3908Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4068 39.6482C58.4634 40.3285 60.7265 40.4384 62.964 39.8418C65.2014 39.2452 67.1061 38.0239 68.5454 36.4115C66.4888 35.7312 64.2256 35.6213 61.9882 36.2179C59.7508 36.8145 57.846 38.0358 56.4068 39.6482Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 49.3585C22.0474 50.0388 24.3105 50.1487 26.5479 49.5521C28.7854 48.9555 30.6901 47.7342 32.1294 46.1218C30.0728 45.4415 27.8096 45.3316 25.5722 45.9282C23.3347 46.5248 21.43 47.746 19.9907 49.3585Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.835 42.885C58.6446 44.0718 60.8021 44.7609 63.1184 44.7609C65.4348 44.7609 67.5922 44.0718 69.4018 42.885C67.5922 41.6982 65.4348 41.0091 63.1184 41.0091C60.802 41.0091 58.6446 41.6982 56.835 42.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1344 42.885C20.944 44.0718 23.1014 44.7609 25.4178 44.7609C27.7341 44.7609 29.8916 44.0718 31.7012 42.885C29.8916 41.6982 27.7341 41.0091 25.4178 41.0091C23.1014 41.0091 20.944 41.6982 19.1344 42.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4068 46.1217C57.8461 47.7342 59.7508 48.9555 61.9882 49.5521C64.2256 50.1487 66.4888 50.0388 68.5454 49.3585C67.1061 47.746 65.2014 46.5248 62.964 45.9282C60.7265 45.3316 58.4634 45.4415 56.4068 46.1217Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9908 36.4115C21.43 38.0239 23.3348 39.2452 25.5722 39.8418C27.8096 40.4384 30.0728 40.3285 32.1294 39.6482C30.6901 38.0358 28.7854 36.8145 26.5479 36.2179C24.3105 35.6213 22.0474 35.7312 19.9908 36.4115Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1467 49.1473C56.1182 51.0725 57.6406 52.7404 59.6466 53.8917C61.6525 55.0431 63.8667 55.5199 66.0295 55.3937C65.0581 53.4685 63.5356 51.8006 61.5296 50.6492C59.5237 49.4979 57.3095 49.0211 55.1467 49.1473Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4982 30.4079C23.4696 32.3331 24.9921 34.001 26.998 35.1524C29.004 36.3038 31.2182 36.7806 33.381 36.6544C32.4095 34.7292 30.8871 33.0613 28.8811 31.9099C26.8752 30.7586 24.661 30.2817 22.4982 30.4079Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1513 51.7375C53.5889 53.8473 54.6257 55.8505 56.2639 57.4793C57.902 59.108 59.9168 60.1389 62.0387 60.574C61.601 58.4643 60.5642 56.461 58.9261 54.8323C57.2879 53.2035 55.2732 52.1726 53.1513 51.7375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.489 25.2276C26.9266 27.3374 27.9635 29.3406 29.6016 30.9694C31.2398 32.5982 33.2545 33.6291 35.3764 34.0642C34.9388 31.9544 33.902 29.9512 32.2638 28.3224C30.6257 26.6936 28.6109 25.6627 26.489 25.2276Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5502 53.7254C50.4242 55.876 50.9047 58.078 52.0634 60.0733C53.2221 62.0685 54.9001 63.5831 56.8365 64.55C56.9625 62.3993 56.482 60.1973 55.3233 58.2021C54.1646 56.2069 52.4866 54.6923 50.5502 53.7254Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6912 21.2517C31.5652 23.4023 32.0457 25.6043 33.2044 27.5995C34.3631 29.5947 36.041 31.1094 37.9775 32.0762C38.1035 29.9256 37.623 27.7236 36.4643 25.7284C35.3056 23.7332 33.6276 22.2185 31.6912 21.2517Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5207 54.9757C46.8397 57.0206 46.7311 59.2713 47.3314 61.497C47.9317 63.7227 49.1586 65.6179 50.7776 67.0506C51.4586 65.0057 51.5672 62.7549 50.9669 60.5293C50.3666 58.3036 49.1397 56.4084 47.5207 54.9757Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7501 18.7511C37.0691 20.796 36.9605 23.0467 37.5608 25.2724C38.1611 27.498 39.388 29.3933 41.007 30.8259C41.688 28.7811 41.7966 26.5303 41.1963 24.3047C40.596 22.079 39.3691 20.1838 37.7501 18.7511Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3458 12.5596C43.6138 13.9925 44.1276 15.2076 44.226 15.636C44.9191 14.0276 44.7352 14.7333 46.1956 12.3234C47.3639 10.3955 47.1269 8.54206 46.8623 7.85635C46.645 7.34023 46.0164 6.09881 45.2411 5.26206C44.4658 4.4253 44.0314 3.02498 43.9111 2.42941C43.7366 3.8215 43.379 4.73887 42.6386 5.65723C42.0462 6.39192 41.5951 7.5871 41.4436 8.09286C41.216 8.98475 41.0778 11.1268 42.3458 12.5596Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3458 80.9667C43.6138 82.3996 44.1276 83.6147 44.226 84.0431C44.9191 82.4347 44.7352 83.1404 46.1956 80.7305C47.3639 78.8026 47.1269 76.9492 46.8623 76.2635C46.645 75.7474 46.0164 74.5059 45.2411 73.6692C44.4658 72.8324 44.0314 71.4321 43.9111 70.8365C43.7366 72.2286 43.379 73.146 42.6386 74.0643C42.0462 74.799 41.5951 75.9942 41.4436 76.5C41.216 77.3919 41.0778 79.5339 42.3458 80.9667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3915 13.1245C51.2436 14.8352 51.4239 16.1412 51.4075 16.5803C52.4953 15.2053 52.1341 15.8396 54.1715 13.8879C55.8014 12.3266 56.0545 10.4753 55.9773 9.74481C55.9016 9.19029 55.6173 7.82928 55.0861 6.82135C54.5548 5.81342 54.4994 4.34892 54.5381 3.74266C54.0075 5.04237 53.4234 5.83637 52.4694 6.53273C51.7062 7.08983 50.9596 8.12809 50.6817 8.57758C50.2299 9.38047 49.5393 11.4139 50.3915 13.1245Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6001 79.2007C33.4522 80.9113 33.6325 82.2173 33.6161 82.6565C34.7039 81.2814 34.3427 81.9158 36.3801 79.9641C38.01 78.4028 38.2631 76.5515 38.1859 75.821C38.1102 75.2665 37.8259 73.9055 37.2947 72.8975C36.7634 71.8896 36.708 70.4251 36.7467 69.8188C36.2161 71.1185 35.632 71.9126 34.678 72.6089C33.9148 73.166 33.1682 74.2043 32.8903 74.6538C32.4385 75.4566 31.7479 77.4901 32.6001 79.2007Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0161 15.7424C58.3943 17.6143 58.2287 18.9222 58.0987 19.3422C59.507 18.2941 58.9932 18.8138 61.4688 17.4534C63.4492 16.3651 64.1752 14.642 64.2906 13.9166C64.3617 13.3615 64.4411 11.9736 64.1901 10.8632C63.9391 9.75277 64.2664 8.32389 64.4615 7.74825C63.6109 8.86702 62.8403 9.48353 61.7376 9.91045C60.8555 10.252 59.8643 11.0626 59.479 11.4252C58.8338 12.0843 57.6379 13.8706 58.0161 15.7424Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6457 74.9847C24.0239 76.8566 23.8584 78.1645 23.7283 78.5845C25.1367 77.5364 24.6229 78.0561 27.0984 76.6957C29.0789 75.6074 29.8048 73.8844 29.9202 73.1589C29.9913 72.6038 30.0707 71.2159 29.8197 70.1055C29.5687 68.9951 29.8961 67.5662 30.0911 66.9906C29.2406 68.1093 28.4699 68.7258 27.3673 69.1528C26.4852 69.4943 25.494 70.3049 25.1086 70.6675C24.4634 71.3266 23.2675 73.1129 23.6457 74.9847Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7 20.2349C64.5785 22.1404 64.0784 23.3611 63.8435 23.7333C65.4765 23.0837 64.845 23.4534 67.5901 22.7769C69.7861 22.2358 70.9354 20.7584 71.2356 20.0874C71.4486 19.5695 71.8863 18.2494 71.9326 17.1121C71.979 15.9749 72.6668 14.679 73.0049 14.1733C71.8923 15.0348 70.9876 15.4318 69.8115 15.5602C68.8707 15.6629 67.7024 16.1906 67.2359 16.4416C66.4412 16.9121 64.8215 18.3295 64.7 20.2349Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0929 68.6061C15.9714 70.5116 15.4713 71.7323 15.2365 72.1045C16.8695 71.4549 16.238 71.8245 18.983 71.1481C21.179 70.6069 22.3284 69.1296 22.6285 68.4586C22.8416 67.9407 23.2792 66.6206 23.3256 65.4833C23.3719 64.3461 24.0597 63.0502 24.3978 62.5444C23.2853 63.406 22.3806 63.803 21.2045 63.9314C20.2636 64.0341 19.0954 64.5618 18.6288 64.8128C17.8342 65.2833 16.2145 66.7007 16.0929 68.6061Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9877 26.2959C69.3748 28.1051 68.5743 29.1555 68.2506 29.4545C69.9969 29.2476 69.2908 29.442 72.1182 29.4956C74.3801 29.5385 75.8746 28.4076 76.339 27.8367C76.6795 27.3913 77.4456 26.2289 77.7861 25.1424C78.1266 24.0558 79.1281 22.9813 79.5862 22.5798C78.2875 23.1255 77.3103 23.2759 76.1409 23.097C75.2054 22.9539 73.9397 23.1627 73.4238 23.285C72.5339 23.5348 70.6007 24.4867 69.9877 26.2959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4565 60.4995C9.84351 62.3088 9.04299 63.3591 8.71934 63.6581C10.4656 63.4512 9.75953 63.6456 12.5869 63.6992C14.8489 63.7421 16.3433 62.6112 16.8077 62.0403C17.1482 61.5949 17.9143 60.4325 18.2548 59.346C18.5954 58.2594 19.5968 57.1849 20.0549 56.7834C18.7562 57.3291 17.7791 57.4795 16.6096 57.3006C15.6741 57.1575 14.4084 57.3663 13.8925 57.4886C13.0026 57.7384 11.0694 58.6903 10.4565 60.4995Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.519 33.5123C72.4564 35.102 71.4099 35.9104 71.0195 36.1158C72.7601 36.3658 72.0275 36.3717 74.7447 37.1517C76.9184 37.7757 78.656 37.0682 79.2531 36.6364C79.6978 36.2939 80.7401 35.3684 81.3516 34.4066C81.9631 33.4448 83.2099 32.6648 83.7569 32.395C82.3605 32.5876 81.3775 32.4812 80.2945 32.0072C79.428 31.628 78.1512 31.5037 77.621 31.4889C76.6964 31.501 74.5816 31.9226 73.519 33.5123Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12046 51.2174C6.05785 52.8071 5.01143 53.6155 4.62105 53.8209C6.36161 54.0709 5.62902 54.0768 8.34615 54.8568C10.5198 55.4809 12.2575 54.7733 12.8546 54.3416C13.2993 53.999 14.3416 53.0736 14.9531 52.1117C15.5646 51.1499 16.8114 50.3699 17.3583 50.1001C15.962 50.2927 14.979 50.1864 13.8959 49.7123C13.0295 49.3331 11.7527 49.2088 11.2225 49.1941C10.2979 49.2061 8.18307 49.6277 7.12046 51.2174Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.053 41.3923C73.6131 42.6542 72.3922 43.1654 71.9616 43.2634C73.5779 43.9531 72.8687 43.7701 75.2904 45.2234C77.2277 46.386 79.0902 46.1502 79.7792 45.8869C80.2979 45.6706 81.5453 45.0451 82.3862 44.2736C83.227 43.502 84.6342 43.0697 85.2326 42.95C83.8338 42.7763 82.9119 42.4204 81.9891 41.6836C81.2508 41.0942 80.0498 40.6452 79.5416 40.4944C78.6453 40.268 76.4929 40.1305 75.053 41.3923Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3122 41.3924C4.87235 42.6542 3.65135 43.1655 3.22083 43.2634C4.83708 43.9532 4.12791 43.7702 6.54958 45.2235C8.48692 46.3861 10.3494 46.1502 11.0384 45.887C11.557 45.6707 12.8045 45.0452 13.6454 44.2736C14.4862 43.5021 15.8934 43.0698 16.4918 42.9501C15.0929 42.7764 14.1711 42.4205 13.2483 41.6837C12.51 41.0943 11.309 40.6453 10.8008 40.4945C9.90451 40.268 7.75206 40.1305 6.3122 41.3924Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4853 49.3989C72.7664 50.2469 71.454 50.4263 71.0127 50.41C72.3945 51.4925 71.757 51.1332 73.7182 53.1606C75.2872 54.7826 77.1475 55.0345 77.8815 54.9577C78.4388 54.8823 79.8064 54.5994 80.8193 54.0708C81.8321 53.5421 83.3038 53.4869 83.913 53.5254C82.6069 52.9974 81.8091 52.4162 81.1093 51.4668C80.5495 50.7073 79.5062 49.9643 79.0545 49.6877C78.2477 49.2381 76.2043 48.5509 74.4853 49.3989Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08684 31.6939C6.36786 32.5419 5.05549 32.7213 4.61418 32.705C5.99595 33.7876 5.35854 33.4282 7.31973 35.4556C8.88867 37.0776 10.749 37.3295 11.483 37.2527C12.0403 37.1773 13.4079 36.8944 14.4208 36.3658C15.4336 35.8371 16.9053 35.7819 17.5145 35.8204C16.2084 35.2924 15.4106 34.7112 14.7108 33.7618C14.151 33.0023 13.1076 32.2593 12.656 31.9827C11.8492 31.5331 9.80582 30.8459 8.08684 31.6939Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8547 56.9865C69.9737 57.3629 68.6594 57.1981 68.2374 57.0687C69.2905 58.4703 68.7683 57.9589 70.1354 60.4225C71.229 62.3933 72.9604 63.1157 73.6894 63.2306C74.2473 63.3013 75.6419 63.3803 76.7577 63.1305C77.8736 62.8808 79.3094 63.2065 79.8878 63.4006C78.7636 62.5542 78.1441 61.7873 77.7151 60.69C77.3719 59.8122 76.5574 58.8258 76.193 58.4423C75.5306 57.8002 73.7356 56.6102 71.8547 56.9865Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3234 22.783C10.4424 23.1594 9.12813 22.9946 8.7061 22.8652C9.75925 24.2668 9.23703 23.7555 10.6041 26.219C11.6977 28.1898 13.4291 28.9122 14.1582 29.0271C14.716 29.0978 16.1106 29.1768 17.2264 28.9271C18.3423 28.6773 19.7781 29.003 20.3566 29.1971C19.2323 28.3507 18.6128 27.5838 18.1838 26.4865C17.8406 25.6087 17.0261 24.6223 16.6617 24.2388C15.9993 23.5968 14.2044 22.4067 12.3234 22.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3402 63.638C65.4255 63.5171 64.1988 63.0194 63.8248 62.7857C64.4776 64.4108 64.1061 63.7824 64.7859 66.514C65.3297 68.6994 66.8142 69.8432 67.4885 70.1419C68.009 70.3539 69.3355 70.7894 70.4783 70.8355C71.6211 70.8816 72.9233 71.5661 73.4315 71.9026C72.5657 70.7954 72.1668 69.8951 72.0378 68.7247C71.9346 67.7884 71.4043 66.6258 71.1521 66.1616C70.6793 65.3708 69.255 63.7589 67.3402 63.638Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7331 15.2669C16.8184 15.146 15.5917 14.6484 15.2177 14.4147C15.8705 16.0397 15.499 15.4113 16.1788 18.143C16.7226 20.3283 18.2071 21.4721 18.8814 21.7708C19.4018 21.9828 20.7284 22.4183 21.8712 22.4645C23.0139 22.5106 24.3161 23.1951 24.8244 23.5315C23.9586 22.4244 23.5597 21.5241 23.4307 20.3537C23.3275 19.4174 22.7972 18.2548 22.545 17.7905C22.0722 16.9997 20.6479 15.3879 18.7331 15.2669Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2497 68.9001C59.4316 68.2901 58.3762 67.4935 58.0757 67.1714C58.2836 68.9092 58.0882 68.2065 58.0344 71.0202C57.9912 73.2712 59.1277 74.7583 59.7014 75.2205C60.1489 75.5593 61.317 76.3217 62.4089 76.6606C63.5007 76.9995 64.5805 77.996 64.9839 78.452C64.4356 77.1595 64.2844 76.1871 64.4642 75.0234C64.608 74.0924 64.3982 72.8329 64.2753 72.3195C64.0243 71.4338 63.0677 69.5101 61.2497 68.9001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8793 9.65786C25.0612 9.04789 24.0058 8.25125 23.7053 7.92917C23.9132 9.66697 23.7178 8.96431 23.6639 11.778C23.6208 14.0289 24.7573 15.5161 25.331 15.9783C25.7785 16.3171 26.9466 17.0795 28.0384 17.4184C29.1303 17.7572 30.2101 18.7538 30.6135 19.2097C30.0652 17.9173 29.914 16.9449 30.0938 15.7812C30.2376 14.8502 30.0278 13.5907 29.9049 13.0773C29.6539 12.1916 28.6973 10.2678 26.8793 9.65786Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9981 72.4142C52.4006 71.3567 51.5883 70.3154 51.3819 69.9269C51.1307 71.659 51.1247 70.93 50.3409 73.6339C49.7139 75.7971 50.4248 77.5263 50.8587 78.1205C51.2029 78.563 52.1329 79.6002 53.0994 80.2088C54.0659 80.8174 54.8497 82.0581 55.1208 82.6024C54.9273 81.2128 55.0342 80.2345 55.5105 79.1568C55.8916 78.2945 56.0165 77.0239 56.0313 76.4963C56.0192 75.5762 55.5956 73.4716 53.9981 72.4142Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2066 6.33805C34.6092 5.28059 33.7969 4.23926 33.5904 3.85077C33.3392 5.58289 33.3333 4.85386 32.5495 7.55779C31.9224 9.72093 32.6334 11.4501 33.0672 12.0443C33.4114 12.4869 34.3414 13.5241 35.3079 14.1327C36.2744 14.7412 37.0583 15.9819 37.3294 16.5262C37.1359 15.1366 37.2427 14.1584 37.719 13.0806C38.1001 12.2184 38.225 10.9478 38.2399 10.4202C38.2277 9.5001 37.8041 7.3955 36.2066 6.33805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3199 5.16855C49.6544 6.5574 49.0724 7.90033 48.9897 8.39819C48.9025 7.68348 48.4845 5.99414 47.5097 4.95449C46.5349 3.91483 46.0355 2.24946 45.8644 1.55823C45.8142 0.995447 46.2711 0.0948956 47.0676 0.247032C47.8642 0.399168 47.9929 1.21401 47.9577 1.60242C47.9092 1.92243 47.8426 2.73422 47.9642 3.42127C48.0859 4.10831 48.3767 4.98837 48.5069 5.34252C48.6662 5.82074 48.9856 7.10139 48.9897 8.39819C49.1447 7.10016 50.0195 5.46019 50.4376 4.80246C50.5637 4.62898 50.8974 4.14745 51.2236 3.60915C51.5498 3.07085 51.6772 2.2865 51.7002 1.96161C51.8011 1.50673 52.2084 0.644109 53.0297 0.832584C53.851 1.02106 53.819 2.02386 53.7004 2.5017C53.6009 2.81196 52.9854 3.7797 51.3199 5.16855Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4797 3.34854C49.6708 4.74294 49.1942 6.51428 49.057 7.22566C49.1978 5.67203 48.9471 4.91293 48.7684 3.57487C48.6255 2.50442 48.7384 1.68567 48.7923 1.40621L48.8795 1.14627C49.5201 0.130649 50.296 0.389491 50.6039 0.645865C50.8996 0.965754 51.2887 1.95413 50.4797 3.34854Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1404 82.8989C38.7856 81.4862 39.3479 80.135 39.4235 79.636C39.521 80.3494 39.9635 82.0325 40.9533 83.0581C41.9431 84.0836 42.4667 85.7416 42.6478 86.4303C42.7063 86.9923 42.2625 87.8993 41.4638 87.7587C40.6652 87.618 40.5246 86.8051 40.5541 86.4162C40.598 86.0955 40.6527 85.2829 40.5211 84.5976C40.3896 83.9124 40.0859 83.0367 39.9506 82.6844C39.7844 82.2085 39.4464 80.9326 39.4235 79.636C39.2873 80.9361 38.4364 82.5885 38.028 83.2522C37.9044 83.4275 37.5777 83.9138 37.2594 84.4567C36.9411 84.9997 36.8251 85.7858 36.8068 86.111C36.7125 86.5672 36.3178 87.4356 35.4939 87.259C34.6699 87.0824 34.6873 86.0792 34.799 85.5997C34.894 85.2881 35.4953 84.3116 37.1404 82.8989Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.007 84.7066C38.7955 83.3007 39.2464 81.5227 39.3732 80.8094C39.255 82.3649 39.5167 83.1203 39.7148 84.4557C39.8733 85.5239 39.7723 86.3442 39.7225 86.6244L39.6391 86.8856C39.0133 87.9103 38.2337 87.6627 37.9221 87.4108C37.6218 87.0952 37.2184 86.1125 38.007 84.7066Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1778 8.30982C59.2079 9.22238 58.2965 10.3697 58.087 10.8292C58.1887 10.1164 58.2243 8.377 57.5532 7.1217C56.882 5.8664 56.8328 4.12915 56.8473 3.41741C56.9451 2.86085 57.6207 2.10867 58.3505 2.46078C59.0803 2.81289 58.9927 3.63313 58.8577 3.99923C58.7276 4.29585 58.4522 5.06284 58.391 5.75779C58.3298 6.45275 58.3818 7.37773 58.4155 7.75335C58.4449 8.2563 58.4204 9.57559 58.087 10.8292C58.5744 9.61537 59.8459 8.25661 60.4208 7.72895C60.5877 7.59387 61.0353 7.2147 61.4904 6.77876C61.9455 6.34281 62.2726 5.61801 62.3792 5.3101C62.5951 4.89673 63.2128 4.16839 63.9571 4.56198C64.7014 4.95556 64.4097 5.91597 64.1708 6.34697C63.994 6.62102 63.1478 7.39726 61.1778 8.30982Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8397 6.33543C59.6956 7.47398 58.7746 9.0622 58.457 9.71399C58.9971 8.24958 58.9524 7.45178 59.1278 6.11329C59.2681 5.0425 59.5901 4.28073 59.7149 4.02466L59.8667 3.79605C60.7496 2.98002 61.4318 3.4299 61.6626 3.75684C61.8649 4.14198 61.9837 5.19689 60.8397 6.33543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2653 79.7394C29.2218 78.7986 30.1164 77.6383 30.3191 77.1758C30.2278 77.89 30.2175 79.6298 30.9068 80.8753C31.5962 82.1208 31.6707 83.8571 31.6665 84.569C31.5768 85.1269 30.9123 85.8887 30.1774 85.5472C29.4425 85.2056 29.5182 84.3842 29.6479 84.0162C29.7736 83.7177 30.0379 82.9468 30.089 82.2511C30.1401 81.5553 30.0746 80.6312 30.0354 80.2561C29.9987 79.7536 30.004 78.4341 30.3191 77.1758C29.8495 78.3965 28.5978 79.7735 28.0307 80.3093C27.8658 80.4468 27.4237 80.8324 26.975 81.2749C26.5264 81.7173 26.2098 82.4467 26.1076 82.7562C25.8979 83.1726 25.2908 83.9097 24.5408 83.5269C23.7909 83.1441 24.0686 82.1796 24.3011 81.7452C24.474 81.4686 25.3088 80.6803 27.2653 79.7394Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6321 81.7088C28.7595 80.5539 29.6574 78.9525 29.9654 78.2962C29.4467 79.7683 29.5029 80.5654 29.347 81.9062C29.2223 82.9789 28.9114 83.7453 28.7904 84.0031L28.6419 84.2339C27.771 85.0625 27.0823 84.6225 26.8468 84.2989C26.6389 83.9167 26.5048 82.8637 27.6321 81.7088Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8831 13.8869C67.7429 14.261 66.5642 15.1345 66.2423 15.5244C66.526 14.8621 67.0127 13.1911 66.6909 11.8057C66.3691 10.4203 66.7734 8.7296 66.9725 8.04584C67.2117 7.53344 68.0599 6.98089 68.6733 7.50898C69.2867 8.03707 68.9887 8.8068 68.7631 9.12565C68.5603 9.37867 68.0948 10.0486 67.8549 10.7041C67.615 11.3596 67.4247 12.2665 67.3596 12.638C67.2572 13.1313 66.8904 14.3994 66.2423 15.5244C67.0288 14.4775 68.6104 13.4925 69.3029 13.1309C69.4993 13.0434 70.0302 12.7924 70.5832 12.4886C71.1361 12.1847 71.6406 11.5688 71.8237 11.2989C72.1397 10.9552 72.9258 10.4108 73.5424 10.9826C74.1589 11.5545 73.6274 12.4071 73.2846 12.7619C73.0425 12.981 72.0233 13.5129 69.8831 13.8869Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0699 11.8927C68.6688 12.6978 67.366 13.9947 66.8898 14.5425C67.7923 13.2671 67.9566 12.485 68.4742 11.2373C68.8882 10.2391 69.3974 9.58621 69.5844 9.371L69.7906 9.18928C70.8556 8.62846 71.3976 9.23872 71.5354 9.61395C71.6307 10.0381 71.4711 11.0876 70.0699 11.8927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5486 74.1481C20.6831 73.7432 21.849 72.8529 22.1651 72.4583C21.8911 73.1246 21.4287 74.8025 21.7706 76.1831C22.1125 77.5637 21.7329 79.2601 21.5438 79.9466C21.312 80.4624 20.472 81.0271 19.851 80.5079C19.23 79.9887 19.5167 79.2148 19.7376 78.8927C19.9367 78.6368 20.3925 77.9603 20.6228 77.3014C20.8531 76.6425 21.0302 75.733 21.0899 75.3606C21.1851 74.8658 21.5334 73.5926 22.1651 72.4583C21.3939 73.5165 19.8268 74.5241 19.1397 74.8957C18.9446 74.986 18.4173 75.2446 17.8689 75.5564C17.3204 75.8682 16.8249 76.4912 16.6458 76.7638C16.3348 77.112 15.5567 77.6677 14.9319 77.1047C14.3071 76.5418 14.8261 75.6817 15.1638 75.322C15.4026 75.0994 16.414 74.5529 18.5486 74.1481Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3907 76.1447C19.78 75.3196 21.0638 74.0041 21.532 73.4495C20.6481 74.7377 20.4952 75.5222 19.9958 76.7772C19.5963 77.7812 19.0967 78.4414 18.9128 78.6592L18.7093 78.8439C17.6526 79.42 17.1018 78.8176 16.9585 78.4444C16.857 78.0217 17.0014 76.9699 18.3907 76.1447Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8424 21.5198C74.6778 21.3299 73.3121 21.87 72.8998 22.1638C73.346 21.5971 74.2508 20.1084 74.3003 18.6874C74.3498 17.2663 75.18 15.7373 75.5501 15.1281C75.9145 14.6948 76.8775 14.3795 77.3326 15.0476C77.7877 15.7157 77.2998 16.3824 76.9989 16.6323C76.7372 16.8245 76.1133 17.3517 75.7111 17.9231C75.309 18.4944 74.8893 19.3214 74.7297 19.6635C74.5025 20.1137 73.8184 21.244 72.8998 22.1638C73.9318 21.3551 75.7157 20.811 76.4786 20.6401C76.6911 20.6062 77.2692 20.5005 77.8823 20.3494C78.4955 20.1983 79.1429 19.7334 79.39 19.5198C79.7846 19.2692 80.6855 18.9458 81.1323 19.657C81.5792 20.3682 80.844 21.0548 80.4206 21.3092C80.1298 21.4585 79.0069 21.7097 76.8424 21.5198Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5415 19.6417C75.9787 20.0585 74.3831 20.9756 73.7806 21.3821C74.9841 20.3826 75.3462 19.6695 76.1706 18.5976C76.8302 17.74 77.4918 17.2405 77.7285 17.0809L77.9748 16.9584C79.1494 16.691 79.5142 17.4201 79.5498 17.818C79.5315 18.2523 79.1043 19.2249 77.5415 19.6417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5842 66.5057C13.7513 66.6645 15.1091 66.1048 15.517 65.8051C15.0791 66.3781 14.1961 67.8797 14.1673 69.3013C14.1385 70.723 13.3306 72.2638 12.9693 72.8782C12.6113 73.3167 11.653 73.6458 11.1882 72.9844C10.7234 72.3229 11.2016 71.6492 11.4988 71.395C11.7577 71.1991 12.3738 70.663 12.7677 70.0859C13.1615 69.5088 13.5691 68.6758 13.7237 68.3315C13.9443 67.8781 14.6119 66.738 15.517 65.8051C14.4969 66.6286 12.7212 67.1983 11.9608 67.3801C11.7489 67.4171 11.1723 67.5311 10.5614 67.691C9.95056 67.851 9.30994 68.3252 9.06599 68.5423C8.67507 68.7985 7.77895 69.1349 7.32184 68.4302C6.86472 67.7255 7.58979 67.0284 8.00946 66.7679C8.29811 66.6144 9.41717 66.347 11.5842 66.5057Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9125 68.3937C12.4691 67.9545 14.0512 67.0145 14.6477 66.5994C13.4589 67.6161 13.1071 68.3344 12.2984 69.4181C11.6514 70.285 10.9972 70.7939 10.7628 70.957L10.5183 71.083C9.34765 71.3673 8.97233 70.6436 8.93099 70.2462C8.94292 69.8117 9.35591 68.833 10.9125 68.3937Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5815 30.6884C79.5401 29.9474 78.0804 30.1173 77.6058 30.2949C78.1842 29.8625 79.4453 28.6576 79.8627 27.2976C80.2801 25.9377 81.4796 24.6747 81.9956 24.1816C82.4603 23.8569 83.4724 23.8004 83.7383 24.5629C84.0042 25.3255 83.3594 25.8438 83.0038 26.0077C82.7011 26.1259 81.9613 26.4744 81.4242 26.9228C80.8871 27.3711 80.2667 28.0618 80.0236 28.3511C79.6871 28.7274 78.7323 29.6431 77.6058 30.2949C78.8129 29.7795 80.6775 29.7135 81.4589 29.7449C81.6729 29.7668 82.2589 29.8137 82.8904 29.8257C83.5219 29.8376 84.2682 29.5553 84.5625 29.4126C85.0088 29.2722 85.9631 29.1919 86.2097 29.9939C86.4564 30.7959 85.5677 31.2698 85.0926 31.4065C84.7728 31.4758 83.6229 31.4293 81.5815 30.6884Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7453 29.0543C81.1273 29.0543 79.3475 29.5292 78.6598 29.7667C80.0823 29.1112 80.6176 28.5157 81.6927 27.6926C82.5527 27.0342 83.3217 26.7221 83.5919 26.6288L83.8617 26.574C85.0658 26.6183 85.2285 27.4164 85.1594 27.81C85.0288 28.2247 84.3632 29.0542 82.7453 29.0543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84698 57.3333C8.89894 58.0448 10.356 57.8539 10.828 57.6695C10.2559 58.1102 9.01245 59.3332 8.61489 60.6989C8.21733 62.0647 7.03624 63.3449 6.52747 63.8454C6.06762 64.1768 5.05637 64.2478 4.77944 63.4892C4.50251 62.7306 5.13966 62.203 5.49286 62.034C5.79384 61.9114 6.52844 61.5523 7.05896 61.0963C7.58948 60.6403 8.19982 59.9407 8.43867 59.6479C8.76972 59.2668 9.71106 58.3375 10.828 57.6695C9.62848 58.2022 7.76504 58.2951 6.98326 58.2749C6.76894 58.2561 6.18239 58.2176 5.55074 58.2148C4.9191 58.2119 4.17697 58.505 3.88486 58.6519C3.44061 58.7987 2.48756 58.8928 2.2293 58.0944C1.97103 57.296 2.8527 56.8093 3.32582 56.6658C3.64456 56.5919 4.79502 56.6219 6.84698 57.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70707 58.984C7.32485 58.9606 9.09758 58.4602 9.78173 58.2128C8.36895 58.8887 7.84238 59.4919 6.77937 60.3303C5.92895 61.0011 5.16461 61.3242 4.89584 61.4214L4.62685 61.4801C3.4222 61.4532 3.24789 60.6574 3.31132 60.2629C3.43583 59.8463 4.0893 59.0073 5.70707 58.984Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7774 40.7676C81.9983 39.5261 80.5442 39.3143 80.0395 39.3636C80.7107 39.0949 82.2422 38.2558 82.9991 37.0498C83.7559 35.8437 85.2431 34.9326 85.8698 34.5892C86.403 34.3953 87.3954 34.6014 87.4539 35.4064C87.5124 36.2115 86.7548 36.5461 86.3687 36.6128C86.0455 36.649 85.2403 36.7951 84.6049 37.0898C83.9695 37.3846 83.1906 37.8919 82.8805 38.1087C82.4576 38.3856 81.2972 39.0241 80.0395 39.3636C81.3396 39.1767 83.1578 39.5932 83.9044 39.8247C84.1054 39.9011 84.6592 40.0973 85.2661 40.2715C85.873 40.4457 86.6674 40.3652 86.9886 40.3031C87.4563 40.2825 88.399 40.4507 88.4286 41.2889C88.4582 42.1271 87.4766 42.356 86.9821 42.3656C86.6552 42.3502 85.5566 42.0091 83.7774 40.7676Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3266 39.489C83.7637 39.0723 81.921 39.0726 81.195 39.1249C82.7395 38.8581 83.4114 38.4207 84.664 37.9026C85.666 37.4881 86.4899 37.3848 86.7751 37.3642L87.05 37.3808C88.2016 37.7337 88.1512 38.5465 87.982 38.9089C87.748 39.2759 86.8894 39.9057 85.3266 39.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65957 47.2559C6.45657 48.4716 7.91361 48.6625 8.4175 48.6059C7.75032 48.8843 6.23113 49.7453 5.49191 50.9622C4.75268 52.179 3.27887 53.1114 2.65728 53.4638C2.12691 53.6654 1.13164 53.4736 1.06146 52.6695C0.991267 51.8654 1.74393 51.5199 2.12903 51.4476C2.45163 51.4068 3.25461 51.2491 3.88565 50.9452C4.5167 50.6414 5.28818 50.1229 5.59504 49.9016C6.01394 49.6187 7.1649 48.9635 8.4175 48.6059C7.12032 48.8116 5.29622 48.4213 4.54631 48.2005C4.3442 48.1271 3.78763 47.9389 3.17825 47.7735C2.56887 47.608 1.77581 47.6999 1.45545 47.7666C0.988155 47.794 0.0431088 47.6394 0.00129861 46.8017C-0.0405115 45.9639 0.937678 45.721 1.432 45.7042C1.7591 45.7149 2.86256 46.0402 4.65957 47.2559Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1292 48.5567C4.69792 48.9508 6.54041 48.924 7.26557 48.8613C5.72516 49.1503 5.05965 49.5973 3.81479 50.1334C2.81891 50.5622 1.99657 50.6775 1.71169 50.7021L1.4366 50.6895C0.279994 50.3532 0.318579 49.5397 0.482447 49.175C0.711062 48.8047 1.56047 48.1626 3.1292 48.5567Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2805 51.0708C81.8849 49.4134 80.5354 48.8343 80.0351 48.7519C80.7533 48.6652 82.4509 48.2492 83.4956 47.2791C84.5404 46.3091 86.2139 45.8121 86.9085 45.6419C87.474 45.5918 88.3789 46.0465 88.2261 46.8392C88.0732 47.6319 87.2544 47.76 86.8641 47.7249C86.5425 47.6767 85.7267 47.6104 85.0363 47.7315C84.3459 47.8525 83.4616 48.1419 83.1057 48.2715C82.6252 48.43 81.3382 48.7479 80.0351 48.7519C81.3395 48.9062 82.9875 49.7768 83.6484 50.1928C83.8227 50.3183 84.3066 50.6504 84.8475 50.975C85.3885 51.2996 86.1767 51.4264 86.5031 51.4492C86.9602 51.5497 87.827 51.955 87.6376 52.7723C87.4482 53.5896 86.4406 53.5578 85.9604 53.4398C85.6486 53.3407 84.6762 52.7282 83.2805 51.0708Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1094 50.2347C83.7082 49.4297 81.9282 48.9554 81.2134 48.8189C82.7746 48.959 83.5374 48.7096 84.882 48.5318C85.9577 48.3895 86.7804 48.5018 87.0612 48.5555L87.3224 48.6423C88.343 49.2797 88.0829 50.0519 87.8253 50.3583C87.5038 50.6526 86.5106 51.0397 85.1094 50.2347Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17109 36.9602C6.59067 38.5973 7.94843 39.157 8.44986 39.2321C7.733 39.3292 6.04165 39.7696 5.01113 40.7546C3.98062 41.7395 2.31453 42.2606 1.62247 42.4408C1.05773 42.499 0.14627 42.0574 0.287607 41.2626C0.428945 40.4678 1.24582 40.3279 1.63659 40.3573C1.95883 40.4009 2.77546 40.4554 3.46402 40.3245C4.15258 40.1935 5.03263 39.8914 5.38659 39.7567C5.86479 39.5913 7.14693 39.2549 8.44986 39.2321C7.1434 39.0966 5.48294 38.2499 4.81602 37.8434C4.63989 37.7205 4.15123 37.3953 3.60564 37.0786C3.06005 36.7618 2.27011 36.6463 1.94334 36.6282C1.48483 36.5343 0.612198 36.1416 0.789689 35.3216C0.96718 34.5017 1.97523 34.5189 2.45706 34.6301C2.77025 34.7246 3.75151 35.323 5.17109 36.9602Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35455 37.8225C4.76731 38.6072 6.554 39.0559 7.27075 39.1821C5.70768 39.0645 4.94858 39.3249 3.60672 39.522C2.53323 39.6798 1.70894 39.5793 1.42736 39.5297L1.16492 39.4467C0.135185 38.824 0.384034 38.0481 0.637177 37.738C0.954315 37.4392 1.94178 37.0378 3.35455 37.8225Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1239 60.8809C79.2069 58.9205 78.0541 58.0135 77.5922 57.8051C78.3085 57.9063 80.0564 57.9417 81.3179 57.2738C82.5793 56.6059 84.325 56.5569 85.0402 56.5713C85.5995 56.6687 86.3553 57.341 86.0015 58.0672C85.6477 58.7935 84.8234 58.7064 84.4556 58.572C84.1575 58.4426 83.3868 58.1685 82.6884 58.1076C81.9901 58.0466 81.0606 58.0984 80.6831 58.132C80.1777 58.1612 78.852 58.1369 77.5922 57.8051C78.812 58.2901 80.1774 59.5555 80.7076 60.1275C80.8434 60.2936 81.2244 60.7391 81.6625 61.1919C82.1005 61.6448 82.8289 61.9703 83.1383 62.0764C83.5537 62.2912 84.2856 62.9059 83.8901 63.6466C83.4946 64.3873 82.5295 64.0971 82.0964 63.8594C81.821 63.6834 81.0409 62.8413 80.1239 60.8809Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.108 60.5444C80.9639 59.4059 79.3679 58.4893 78.7129 58.1733C80.1845 58.7107 80.9862 58.6663 82.3312 58.8408C83.4072 58.9805 84.1727 59.3009 84.43 59.425L84.6597 59.5761C85.4797 60.4547 85.0277 61.1336 84.6991 61.3632C84.3121 61.5646 83.252 61.6828 82.108 60.5444Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3459 27.133C9.29131 29.08 10.4573 29.9703 10.9221 30.172C10.2044 30.0811 8.45613 30.0709 7.20455 30.7569C5.95297 31.4429 4.20814 31.517 3.49279 31.5129C2.93216 31.4236 2.16662 30.7623 2.50985 30.031C2.85308 29.2997 3.6785 29.375 4.0483 29.504C4.34822 29.6291 5.12285 29.8921 5.82201 29.943C6.52117 29.9938 7.44981 29.9286 7.82674 29.8897C8.33166 29.8531 9.65761 29.8584 10.9221 30.172C9.69535 29.7046 8.3117 28.4591 7.77321 27.8947C7.63506 27.7305 7.24761 27.2906 6.803 26.8441C6.35839 26.3976 5.62539 26.0827 5.31447 25.981C4.89601 25.7722 4.15526 25.1681 4.53995 24.4218C4.92465 23.6755 5.89386 23.9518 6.33037 24.1832C6.60829 24.3552 7.40048 25.186 8.3459 27.133Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36698 27.4981C7.52751 28.6199 9.13664 29.5135 9.79614 29.82C8.31692 29.3038 7.51596 29.3598 6.16854 29.2046C5.09061 29.0805 4.32054 28.7711 4.06145 28.6507L3.82955 28.5029C2.99685 27.6362 3.43901 26.9509 3.76417 26.7166C4.14822 26.5096 5.20645 26.3762 6.36698 27.4981Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5196 69.5439C74.1437 67.4141 73.266 66.2411 72.8741 65.9208C73.5397 66.203 75.2188 66.6875 76.611 66.3672C78.0031 66.047 79.7021 66.4492 80.3892 66.6474C80.9041 66.8855 81.4594 67.7295 80.9287 68.3399C80.398 68.9503 79.6245 68.6538 79.3041 68.4293C79.0499 68.2275 78.3767 67.7643 77.718 67.5255C77.0593 67.2868 76.148 67.0975 75.7747 67.0326C75.2789 66.9307 74.0047 66.5657 72.8741 65.9208C73.9262 66.7034 74.916 68.2774 75.2794 68.9665C75.3673 69.1619 75.6194 69.6903 75.9248 70.2406C76.2302 70.7908 76.8491 71.2928 77.1203 71.4751C77.4657 71.7895 78.0128 72.5718 77.4381 73.1854C76.8634 73.7989 76.0067 73.27 75.6502 72.9288C75.4299 72.6879 74.8955 71.6737 74.5196 69.5439Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5235 69.7298C75.7145 68.3354 74.4113 67.039 73.8609 66.5651C75.1425 67.4633 75.9284 67.6268 77.1822 68.1418C78.1853 68.5538 78.8413 69.0605 79.0576 69.2467L79.2402 69.4518C79.8037 70.5117 79.1905 71.051 78.8134 71.1882C78.3872 71.283 77.3326 71.1242 76.5235 69.7298Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9645 18.4586C14.3714 20.5827 15.266 21.743 15.6625 22.0576C14.9929 21.7849 13.3069 21.3247 11.9196 21.665C10.5322 22.0053 8.82757 21.6275 8.13767 21.4392C7.61936 21.2086 7.0519 20.3726 7.57364 19.7547C8.09537 19.1367 8.87309 19.422 9.19672 19.6419C9.45388 19.84 10.1337 20.2935 10.7958 20.5227C11.4579 20.7519 12.3719 20.9282 12.7461 20.9876C13.2433 21.0824 14.5227 21.429 15.6625 22.0576C14.5992 21.2902 13.5866 19.7306 13.2133 19.0468C13.1225 18.8527 12.8627 18.328 12.5493 17.7822C12.236 17.2364 11.6099 16.7433 11.336 16.565C10.9861 16.2556 10.4277 15.4812 10.9934 14.8595C11.5591 14.2377 12.4234 14.7542 12.7849 15.0902C13.0086 15.3279 13.5577 16.3344 13.9645 18.4586Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9581 18.3015C12.7873 19.6841 14.1092 20.9616 14.6665 21.4275C13.372 20.5479 12.5837 20.3957 11.3226 19.8988C10.3137 19.5013 9.6503 19.0041 9.43136 18.821L9.24579 18.6186C8.66688 17.5669 9.27221 17.0188 9.64724 16.8763C10.072 16.7753 11.1289 16.9189 11.9581 18.3015Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8495 76.4694C67.0403 74.3153 66.4976 72.9562 66.2024 72.5459C66.7719 72.99 68.2678 73.8904 69.6958 73.9396C71.1238 73.9888 72.6603 74.815 73.2724 75.1834C73.7079 75.546 74.0247 76.5043 73.3533 76.9572C72.682 77.4101 72.012 76.9245 71.7609 76.6251C71.5678 76.3647 71.038 75.7439 70.4638 75.3436C69.8897 74.9434 69.0587 74.5257 68.715 74.367C68.2626 74.1408 67.1267 73.4601 66.2024 72.5459C67.0151 73.5729 67.5618 75.3481 67.7335 76.1074C67.7676 76.3188 67.8738 76.8941 68.0256 77.5043C68.1775 78.1144 68.6447 78.7587 68.8593 79.0046C69.1111 79.3973 69.4361 80.2938 68.7215 80.7385C68.0068 81.1831 67.3168 80.4516 67.0612 80.0302C66.9111 79.7408 66.6587 78.6234 66.8495 76.4694Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7368 77.1651C68.318 75.6099 67.3964 74.022 66.9879 73.4224C67.9923 74.6201 68.7089 74.9805 69.786 75.8009C70.6477 76.4572 71.1497 77.1156 71.3101 77.3511L71.4332 77.5963C71.7019 78.7652 70.9693 79.1282 70.5694 79.1636C70.133 79.1454 69.1556 78.7203 68.7368 77.1651Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6441 11.528C21.4846 13.6846 22.0471 15.0357 22.3482 15.4417C21.7724 15.0059 20.2635 14.1272 18.8349 14.0985C17.4063 14.0699 15.858 13.2659 15.2406 12.9064C14.7999 12.5501 14.4692 11.5965 15.1339 11.1339C15.7986 10.6714 16.4756 11.1473 16.731 11.443C16.9279 11.7006 17.4666 12.3138 18.0465 12.7057C18.6265 13.0977 19.4635 13.5033 19.8095 13.6571C20.2651 13.8767 21.4107 14.541 22.3482 15.4417C21.5207 14.4266 20.9482 12.6594 20.7655 11.9027C20.7283 11.6919 20.6138 11.1181 20.4531 10.5102C20.2924 9.90229 19.8158 9.26477 19.5977 9.02201C19.3402 8.63299 19.0022 7.74122 19.7103 7.28633C20.4184 6.83143 21.119 7.55298 21.3807 7.97061C21.535 8.25786 21.8036 9.37148 21.6441 11.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7469 10.8595C20.1883 12.4086 21.1329 13.983 21.55 14.5767C20.5283 13.3936 19.8066 13.0435 18.7176 12.2387C17.8465 11.5949 17.335 10.9438 17.1711 10.7106L17.0445 10.4672C16.7589 9.30231 17.4861 8.9288 17.8855 8.88767C18.322 8.89953 19.3055 9.31052 19.7469 10.8595Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6363 81.1855C58.3808 79.154 58.2101 77.7014 58.0316 77.2291C58.4662 77.8047 59.677 79.0597 61.0435 79.475C62.4101 79.8904 63.6793 81.0841 64.1748 81.5976C64.5011 82.06 64.5579 83.0672 63.7916 83.3318C63.0253 83.5964 62.5044 82.9548 62.3398 82.6009C62.221 82.2996 61.8708 81.5635 61.4202 81.029C60.9697 80.4945 60.2757 79.8771 59.9849 79.6352C59.6068 79.3002 58.6866 78.3501 58.0316 77.2291C58.5495 78.4303 58.6159 80.2859 58.5843 81.0635C58.5623 81.2765 58.5152 81.8596 58.5032 82.488C58.4912 83.1165 58.7749 83.8592 58.9182 84.152C59.0593 84.5962 59.1401 85.5458 58.3341 85.7913C57.5282 86.0367 57.052 85.1524 56.9146 84.6795C56.8449 84.3613 56.8917 83.217 57.6363 81.1855Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2783 82.3436C59.2783 80.7335 58.801 78.9623 58.5624 78.278C59.2211 79.6936 59.8196 80.2262 60.6466 81.2961C61.3083 82.152 61.6218 82.9172 61.7156 83.1861L61.7707 83.4546C61.7262 84.6529 60.9241 84.8148 60.5287 84.746C60.1119 84.6161 59.2784 83.9537 59.2783 82.3436Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8613 6.81374C30.1463 8.85574 30.3382 10.3057 30.5235 10.7754C30.0806 10.2062 28.8517 8.9687 27.4793 8.57307C26.1068 8.17744 24.8203 7.00208 24.3175 6.49578C23.9845 6.03816 23.9131 5.03183 24.6754 4.75624C25.4377 4.48065 25.9679 5.11471 26.1377 5.46619C26.2609 5.76572 26.6217 6.49675 27.08 7.02469C27.5382 7.55264 28.2412 8.16001 28.5354 8.3977C28.9184 8.72715 29.8522 9.66392 30.5235 10.7754C29.9882 9.58174 29.8949 7.72735 29.9151 6.94936C29.934 6.73608 29.9727 6.15238 29.9755 5.5238C29.9784 4.89522 29.6839 4.15669 29.5363 3.866C29.3888 3.42391 29.2942 2.47548 30.0965 2.21847C30.8988 1.96147 31.3878 2.83886 31.5321 3.30968C31.6064 3.62687 31.5762 4.77174 30.8613 6.81374Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2026 5.67937C29.226 7.28929 29.729 9.05342 29.9775 9.73424C29.2983 8.32833 28.6922 7.80431 27.8496 6.74646C27.1756 5.90017 26.8509 5.13954 26.7533 4.87207L26.6943 4.60439C26.7214 3.40559 27.521 3.23212 27.9174 3.29524C28.336 3.41915 29.1791 4.06944 29.2026 5.67937Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5078 83.3707C48.7554 81.6002 48.9682 80.1532 48.9187 79.651C49.1888 80.3189 50.0319 81.843 51.2438 82.5962C52.4558 83.3493 53.3713 84.8293 53.7164 85.4529C53.9113 85.9836 53.7042 86.9711 52.8952 87.0293C52.0862 87.0876 51.75 86.3336 51.6829 85.9494C51.6465 85.6278 51.4997 84.8265 51.2036 84.1942C50.9074 83.5619 50.3976 82.7867 50.1797 82.4782C49.9015 82.0573 49.2598 80.9025 48.9187 79.651C49.1065 80.9447 48.688 82.7541 48.4553 83.4971C48.3786 83.6972 48.1815 84.2482 48.0064 84.8522C47.8314 85.4562 47.9123 86.2466 47.9746 86.5664C47.9954 87.0317 47.8263 87.9699 46.984 87.9993C46.1417 88.0288 45.9117 87.052 45.902 86.5599C45.9175 86.2345 46.2603 85.1412 47.5078 83.3707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7927 84.9123C49.2114 83.3571 49.2111 81.5234 49.1586 80.8009C49.4267 82.3378 49.8662 83.0065 50.3868 84.253C50.8033 85.2501 50.9072 86.07 50.9278 86.3539L50.9112 86.6274C50.5566 87.7734 49.7397 87.7232 49.3757 87.5549C49.0069 87.3221 48.374 86.4676 48.7927 84.9123Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9879 4.63695C39.7662 6.42522 39.5744 7.87519 39.6312 8.37664C39.3515 7.71269 38.4863 6.20088 37.2635 5.46525C36.0407 4.72961 35.1038 3.26295 34.7497 2.64438C34.5471 2.11658 34.7399 1.12615 35.5479 1.0563C36.3559 0.986455 36.7031 1.73546 36.7757 2.11869C36.8168 2.43973 36.9752 3.23881 37.2806 3.86679C37.5859 4.49477 38.1069 5.26251 38.3293 5.56787C38.6136 5.98474 39.2719 7.13011 39.6312 8.37664C39.4246 7.08575 39.8168 5.27051 40.0387 4.52424C40.1124 4.32311 40.3015 3.76924 40.4678 3.16282C40.6341 2.5564 40.5417 1.76719 40.4747 1.44839C40.4472 0.983359 40.6025 0.0428995 41.4443 0.0012923C42.2861 -0.0403149 42.5303 0.933126 42.5471 1.42505C42.5364 1.75056 42.2095 2.84867 40.9879 4.63695Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6807 3.114C39.2847 4.67511 39.3116 6.50866 39.3746 7.2303C39.0843 5.69737 38.635 5.03508 38.0964 3.79627C37.6654 2.80522 37.5496 1.98688 37.5249 1.70338L37.5375 1.42963C37.8754 0.278635 38.6929 0.317032 39.0594 0.480105C39.4315 0.70761 40.0768 1.5529 39.6807 3.114Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_550_14846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2146 44) rotate(90) scale(44 44.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramStatusFlower);
export default __webpack_public_path__ + "static/media/program-status-flower.e9525629216c2e225a71c2bd05647ffa.svg";
export { ForwardRef as ReactComponent };